<template>
  <div>

    <v-container fluid style="padding: 0px 16px 0 16px; margin-top: 0px;">
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64"
        type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("Stream") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title">
                <v-tooltip v-model="showHelp" location="bottom" nudge-left>
                  <template v-slot:activator="{ props }">
                    <v-icon 
                    :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                      NavbarBtnColorTheme : '5179ef')" 
                    v-bind="props" 
                    size="24"
                    icon="mdi-information-slab-circle-outline">
                  </v-icon>
                  </template>
                  <p class="mb-0">:userid (request MS Team ID)</p>
                  <p class="mb-0">:clearmemory (clear short memory)</p>
                  <p class="mb-0">:memory (show short memory)</p>
                  <p class="mb-0">:lastmemory (show last memory of last conversation)</p>
                  <p class="mb-0">:model (show all model)</p>
                </v-tooltip>
                <v-icon id="openfullstream-stream" v-on:click="OpenFullStream()" v-if="roleId == 0 || roleId == 1" :style="'color: #' + (NavbarBtnColorTheme != null || $NavbarBtnColorTheme != undefined ?
                  NavbarBtnColorTheme : '5179ef')"
                  style=" cursor: pointer; font-size: medium;margin-left: 12px; padding: 10px; margin-right: 5px;" icon="mdi-vector-arrange-above"></v-icon>

                <v-app-bar-nav-icon style="cursor: pointer;" :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                  NavbarBtnColorTheme : '5179ef')"
                  v-on:click="SetPopup = !SetPopup"></v-app-bar-nav-icon>
            </v-toolbar-title>
          </div>
        </v-toolbar>

      </v-skeleton-loader>
      <v-row style="margin-top: 0px;  ">

        <v-col cols="12" style=" padding-bottom: 0px; margin-left: 2px;font-size: 15px;    white-space: nowrap;
         overflow: hidden;text-overflow: ellipsis;    padding-top: 5px;">
          Model {{ (ModelFirst == "" ? "-" : ModelFirst) }} : {{
            (TopicName == "" ? "-" : TopicName) }}

        </v-col>
      </v-row>
      <v-row class="w-fill-available h-fill-available" style="padding-right: 12px;margin-top: 0px;">
        <v-col v-if="SetPopup" class="h-fill-available"
          style="max-width: 300px;background-color: white;margin: 12px; margin-bottom: 25px;
              border-radius: 12px; border: 1px solid #e0e0e0;
              overflow-y: auto; max-height: calc(-244px + 100vh);height: calc(-244px + 100vh) !important;">

          <div class="tool-box">
            <v-row style="margin: 0px;padding: 0px;display: flex;align-items: center;">
              <v-col>
                <label style="font-weight: bold;">Parameters</label>
              </v-col>
            </v-row>
            <v-row style="margin-top: 0px;">
              <v-col cols="12">
                <div class="stream-param-box">
                  <div class="stream-field-row">
                    <span>
                      <v-icon size="18" color="primary" class="stream-field-icon">mdi-account-badge</v-icon>
                      <label class="stream-label">User ID</label>
                    </span>
                    
                    <v-text-field
                      id="user-id-stream"
                      class="stream-text-field"
                      variant="outlined"
                      density="compact"
                      hide-details
                      v-model="User_Id_Show"
                      placeholder="Enter User ID"
                    />
                  </div>
                  <div class="stream-field-row">
                    <span>
                      <v-icon size="18" color="primary" class="stream-field-icon">mdi-timer-outline</v-icon>
                      <label class="stream-label">Time Delay</label>
                    </span>
                    <v-text-field
                      id="time-delay-stream"
                      class="stream-text-field"
                      variant="outlined"
                      density="compact"
                      hide-details
                      v-model="Time_Delay"
                      placeholder="ms"
                      type="number"
                      min="0"
                      @keypress="blockNegative"
                    />
                  </div>
                  <div class="stream-field-row">
                    <span>
                      <v-icon size="18" color="primary" class="stream-field-icon">mdi-shield-lock-outline</v-icon>
                      <label class="stream-label">Access Level</label>
                    </span>
                    <v-select
                      id="access-level-stream"
                      class="stream-text-field"
                      variant="outlined"
                      density="compact"
                      hide-details
                      :items="accessLevelOptions"
                      item-title="title"
                      item-value="value"
                      v-model="AccessLevel"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- Log -->
          <div class="tool-box">
            <v-row style="margin: 0px;padding: 0px;display: flex;align-items: center;">
              <v-col class="col-8" style=" padding-top: 0px; padding-bottom: 0px;">
                <label style="font-weight: bold;">Log</label>
              </v-col>
              <v-col class="col-4" style="display: flex; padding: 0px;text-align: end;
                justify-content: flex-end; align-items: center; height: 45px;">

                <v-btn v-if="LOG_STATUS == false" v-on:click="LOG_STATUS = true"
                variant="text" class="log-toggle-button" icon 
                :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                  NavbarBtnColorTheme : '5179ef')" style="cursor: pointer;">
                  <v-icon size="18">mdi-chevron-down</v-icon> </v-btn>
                <v-btn v-else v-on:click="LOG_STATUS = false"  class="log-toggle-button"  variant="text" 
                icon :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                  NavbarBtnColorTheme : '5179ef')" style="cursor: pointer;">
                  <v-icon size="18">mdi-chevron-up</v-icon> </v-btn>

              </v-col>
            </v-row>
            <div v-if="LOG_STATUS == true">
              <!-- prompt -->
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">System Message</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">

                <v-col style=" padding-top: 0px;">

                  <v-textarea id="DataLog-Prompt-textarea-stream"  class="Log_text_textarea" v-model="DataLog.Prompt" variant="outlined"
                  readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Knowledge</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-Vector-textarea-stream" class="Log_text_textarea" v-model="DataLog.Vector" variant="outlined" 
                  readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">SQL Query</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-ReplySQL-textarea-stream" class="Log_text_textarea" v-model="DataLog.ReplySQL" variant="outlined"
                  readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">SQL Query Result</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-ReplyDataSelect-textarea-stream"  class="Log_text_textarea" v-model="DataLog.ReplyDataSelect" 
                  variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Work Flow</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-FlowActionIntent-textarea-stream" class="Log_text_textarea" v-model="DataLog.FlowActionIntent" variant="outlined"
                  readonly rows="2"></v-textarea>
                </v-col>
              </v-row>

              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Memory</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">

                <v-col style=" padding-top: 0px;">

                  <v-textarea id="DataLog-Memory-textarea-stream" class="Log_text_textarea" v-model="DataLog.Memory" variant="outlined"
                  readonly rows="2"></v-textarea>
                </v-col>
              </v-row>


              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;font-weight: bold;">LLMs Model</label>
                </v-col>
              </v-row>
              <!-- <v-row style="margin-top: 0px;">

                <v-col style=" padding-top: 0px;">

                  <v-textarea v-model="DataLog.GPT_Model" variant="outlined" :disabled="true"></v-textarea>
                </v-col>
              </v-row> -->
              <div style="border: 1px solid;    border-radius: 5px;    padding: 12px;">

                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">ModelID : {{ DataLog.GPT_Model.ModelID }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">ModelName : {{ DataLog.GPT_Model.ModelName }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Provider : {{ DataLog.GPT_Model.Provider }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Model : {{ DataLog.GPT_Model.Model }}</label>
                  </v-col>
                </v-row>

                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">SystemMessage</label>
                    <v-textarea id="DataLog-GPT_Model-promptTemplate-stream" class="Log_text_textarea" v-model="DataLog.GPT_Model.promptTemplate" variant="outlined"
                      readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>

                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <!-- <label style="font-size: 12px;">VectordbName : {{ DataLog.GPT_Model.vectordbName }}</label> -->
                    <label style="font-size: 12px;">KnowledgeDocuments</label>
                    <v-textarea id="DataLog-GPT_Model-vectordbName-stream" class="Log_text_textarea" v-model="DataLog.GPT_Model.vectordbName" variant="outlined"
                      readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Extension : {{ DataLog.GPT_Model.Extension }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Description : {{ DataLog.GPT_Model.Description }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Gender : {{ DataLog.GPT_Model.gender }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">TopN_Chunks : {{ DataLog.GPT_Model.TopVDB }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Internet : {{ DataLog.GPT_Model.internet }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Feedback : {{ DataLog.GPT_Model.feedback }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">HistoryCount : {{ DataLog.GPT_Model.HistoryCount }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">HistoryMinute : {{ DataLog.GPT_Model.HistoryMinute }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Temperature : {{ DataLog.GPT_Model.temperature }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Top_P : {{ DataLog.GPT_Model.top_p }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Frequency_Penalty : {{ DataLog.GPT_Model.frequency_penalty }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Presence_Penalty : {{ DataLog.GPT_Model.presence_penalty }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">Stop_Sequence : {{ DataLog.GPT_Model.Stop }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">MaxTokensResponse : {{ DataLog.GPT_Model.max_tokens }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <label style="font-size: 12px;">IsStream : {{ DataLog.GPT_Model.IsStream }}</label>
                  </v-col>
                </v-row>
                <v-row style="margin-top: 0px;">
                  <v-col style="margin-top: 0px;">
                    <!-- <label style="font-size: 12px;">Endpoint : {{ DataLog.GPT_Model.EndpointURL }}</label> -->
                    <label style="font-size: 12px;">Endpoint</label>
                    <v-textarea id="DataLog-GPT_Model-EndpointURL-stream" class="Log_text_textarea" v-model="DataLog.GPT_Model.EndpointURL" variant="outlined"
                      readonly rows="2"></v-textarea>
                  </v-col>
                </v-row>

              </div>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">{{ $t('UserQuery') }} : {{ DataLog.TextVector }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">{{ $t('OrgVectorSearch') }} : {{ DataLog.Text }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">{{ $t('ModVectorSearch') }} : {{ DataLog.Translate ?? "-" }}</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Vector Cosine</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style=" padding-top: 0px;">
                  <v-textarea id="DataLog-GPT_Model-VectorCoise-stream" class="Log_text_textarea" v-model="DataLog.VectorCoise" 
                  variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">
                <v-col style="margin-top: 0px;">
                  <label style="font-size: 12px;">Private Memory</label>
                </v-col>
              </v-row>
              <v-row style="margin-top: 0px;">

                <v-col style=" padding-top: 0px;">

                  <v-textarea id="DataLog-GPT_Model-Private_Memory-stream" class="Log_text_textarea" v-model="DataLog.Private_Memory"
                  variant="outlined" readonly rows="2"></v-textarea>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- Topic list -->
          <div class="tool-box" style="overflow-y: hidden;">
            <v-row style="margin: 0px; padding: 0px;display: flex;align-items: center;">

              <v-col class="col-8" style=" padding-top: 0px; padding-bottom: 0px;">
                <label style="font-weight: bold;">Topic list</label>
              </v-col>
              <v-col class="col-4" style="display: flex; padding: 0px;text-align: end;
                justify-content: flex-end; align-items: center;height: 45px;">
                <v-btn variant="text" icon 
                  :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ? NavbarBtnColorTheme : '5179ef')"
                  v-on:click="Topic_STATUS = true; Click_History_List(-1, '...', ModelFirst, -1, null);">
                  <v-icon>mdi-chat-plus</v-icon>
                </v-btn>
                <v-btn v-if="Topic_STATUS == false" class="log-toggle-button"
                 v-on:click="Topic_STATUS = true" variant="text" icon 
                 :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                 NavbarBtnColorTheme : '5179ef')" style="cursor: pointer;">
                <v-icon size="18">mdi-chevron-down</v-icon>
              </v-btn>


                <v-btn v-else v-on:click="Topic_STATUS = false" class="log-toggle-button" variant="text" icon 
                  :style="'color: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                  NavbarBtnColorTheme : '5179ef')" style="font-size: 30px; cursor: pointer;">
                  <v-icon size="18">mdi-chevron-up</v-icon> </v-btn>
              </v-col>
            </v-row>
            <div v-if="Topic_STATUS == true" style="padding: 0px;padding-bottom: 9px; ">
              <v-row id="toppic_list_id" style="display: block;">
                <v-col class="col-12 pt-0 pb-2">
                <div v-if="Topic_STATUS == true" style="padding: 0px; ">
                  <v-row id="toppic_list_id" style="display: block;padding-top: 15px;">
                    <v-col class="col-12 pt-0 pb-2">
                      <v-list density="compact" nav class="pa-0">
                        <div v-for="(item, index) in listTopic" :key="index">
                          <!-- Edit Mode -->
                          <v-list-item
                            v-if="item.status == true"
                            :active="Log_History_TopicID == item.topicID"
                            active-color="primary"
                            rounded="lg"
                            class="mb-1 topic-item-editing"
                          >
                            <v-text-field
                              class="stream-topic-name"
                              :id="'TopicId_' + item.topicID"
                              variant="solo-filled"
                              flat
                              autofocus
                              hide-details
                              density="compact"
                              v-model="item.topicName"
                              style="width: 220px;max-width: 100%;"
                              @blur="item.status = false; RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token)"
                              @keyup="keyupKeyRename($event)"
                              @keyup.enter.prevent="item.status = false; RenameTopicStream(item.topicID, item.keyTopic, item.topicName, index, auth_token)"
                            ></v-text-field>

                            <template v-slot:append>
                              <v-menu location="bottom end">
                                <template v-slot:activator="{ props }">
                                  <v-btn variant="text" size="small" icon="mdi-dots-vertical" v-bind="props"></v-btn>
                                </template>
                                <v-list>
                                  <v-list-item link @click="RenameClick(item, 'TopicId_' + item.topicID)">
                                    <v-list-item-title>Rename</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item link @click="DeleteTopicStream(item.topicID, item.keyTopic, index)">
                                    <v-list-item-title>Delete chat</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </template>
                          </v-list-item>

                          <!-- Display Mode -->
                          <v-list-item
                            v-else
                            :active="Log_History_TopicID == item.topicID"
                            active-color="primary"
                            rounded="lg"
                            class="mb-1 topic-item"
                            @click="Click_History_List(item.topicID, item.topicName, item.topicModelID, item.topicModelID_long, item.keyTopic);"
                          >
                            <v-tooltip location="top" :open-delay="150">
                              <template v-slot:activator="{ props }">
                                <v-list-item-title v-bind="props" class="topic-title">
                                  {{ item.topicName }}
                                </v-list-item-title>
                              </template>
                              <span>{{ item.topicName }}</span>
                            </v-tooltip>

                            <template v-slot:append>
                              <v-menu location="bottom end">
                                <template v-slot:activator="{ props }">
                                  <v-btn variant="text" size="small" icon="mdi-dots-vertical" v-bind="props" class="topic-menu-btn"></v-btn>
                                </template>
                                <v-list>
                                  <v-list-item link @click.stop="RenameClick(item, 'TopicId_' + item.topicID)">
                                    <v-list-item-title>Rename</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item link @click.stop="DeleteTopicStream(item.topicID, item.keyTopic, index)">
                                    <v-list-item-title>Delete chat</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </template>
                          </v-list-item>
                        </div>
                      </v-list>
                    </v-col>
                  </v-row>
                </div>
                </v-col>
              </v-row>
            </div>

          </div>
        </v-col>
        <v-col cols="12" style="background-color: white; flex: 1; height: calc(-244px + 100vh);
          display: flex; flex-direction: column; align-items: center; margin: 12px; margin-bottom: 25px;
          border-radius: 12px; border: 1px solid #e0e0e0; padding-bottom: 0px; max-width: 80%;"
          :style="SetPopup ? { maxWidth: '80%' } : { maxWidth: '100%' }">
          <div id="ChatScreId" 
          style=" width: 100%; height: 10px;  overflow-y: auto;  flex-grow: 1;    display: flex; 
                    max-height: 80%;    flex-direction: column; background-color:#edf5ff;
                    border-radius: 12px; margin-bottom: 6px;" ref="ChatScreRef" @scroll="ChatScreScroll">
            <div v-if="Loading_History_Status == true">
              <v-progress-linear indeterminate color="#ff4646" class="mb-0"></v-progress-linear>
            </div>
            <div v-for="(item, index) in listMessage" :id="'ChatId_' + item.id" :key="index">
              <v-row style=" margin: 0px;" v-if="item.messageUser">
                <v-col col="12" class="d-flex flex-row-reverse">
                  <div v-if="item.messageUser != null && (index > 0 ? listMessage[index - 1].messageBot : item.messageBot != null)"
                      style="float: right; height: 35px; width: 35px;  border-radius: 50%;
                          text-align: center;  background-color: rgb(0, 78, 140); 
                          
                        margin-top: 10px;    margin-left: 15px;">
                    <v-icon style="font-size: 30px;padding-top: 1px;color: rgb(255, 255, 255);">mdi-account</v-icon>
                  </div>
                  <div class="stream-message-box" 
                  style="float: right; border-radius: 18px 0px 18px 18px; background: rgb(219, 236, 255);">
                    <p class="stream-request-time" style="right: 12px;white-space: nowrap;">{{ item.requestTime }}</p>
                    <MarkdownRenderer :content="item.messageUser"/>
                  </div>
                </v-col>
              </v-row>
              <v-row style=" margin: 0px;"
                v-if="item.status_Process != 'VoiceStart' && item.status_Process != 'ChatChain' && item.messageBot != null">
                <v-col col="12" class="d-flex">

                  <div style="   float: left; height: 35px; width: 35px;  border-radius: 50%;
                          text-align: center;  background-color: white; 
                        margin-top: 10px;    margin-right: 15px;"
                    v-if="item.messageUser != null && item.messageBot != null">
                    <v-icon style="font-size: 30px;color: rgb(128, 106, 213);">mdi-robot-outline</v-icon>
                  </div>
                  <div v-else style="float: left; height: 35px; width: 35px; text-align: center; 
                    margin-top: 10px; margin-right: 15px;"></div>
                  <!-- Status Indicator (AI Thinking Process) + Fallback Finding Answer -->
                  <div v-if="item.status_Process == 'Process'" style="float: left;">
                    <!-- Status Indicator - แสดงด้านบน -->
                    <StatusIndicator
                      :userId="User_Id"
                      :sessionId="KeyTopic"
                      :autoConnect="true"
                      defaultMessage="Finding answer..."
                      @status-update="onStatusUpdate"
                      ref="statusIndicator"
                    />
                    <!-- Fallback: Finding Answer box (แสดงเมื่อไม่มี status updates) -->
                    <div v-if="!hasStatusUpdates" class="finding-answer-box">
                      <div class="finding-answer-text">Finding answer...</div>
                      <v-progress-linear indeterminate color="rgb(0, 120, 212)" class="mb-3" height="3" rounded></v-progress-linear>
                    </div>
                  </div>
                  <!-- Completed message with status summary above -->
                  <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'"
                    style="float: left; max-width: calc(100% - 65px);">
                    <!-- Status Indicator (collapsed, expandable) - แสดงเฉพาะ item ล่าสุดเท่านั้น -->
                    <StatusIndicator
                      v-if="hasStatusUpdates && savedStatusList.length > 0 && index === listMessage.length - 1"
                      :userId="User_Id"
                      :sessionId="KeyTopic"
                      :autoConnect="false"
                      :initialStatusList="savedStatusList"
                      :initialCompleted="true"
                      ref="statusIndicatorCompleted"
                      style="margin-bottom: 6px;"
                    />
                    <!-- Actual response -->
                    <div class="stream-message-box"
                      style="border-radius: 0px 18px 18px 18px;min-width: 100%;"
                      :style="getBotMessageParts(item.messageBot).accessRequired ? 'flex-wrap: wrap;' : ''"
                      @click="botMessageClick(item.messageBot)">
                      <p class="stream-request-time" style="left: 12px;white-space: nowrap;">{{ item.requestTime }}</p>
                      <MarkdownRenderer
                        v-if="!getBotMessageParts(item.messageBot).accessRequired || getBotMessageParts(item.messageBot).text"
                        :content="getBotMessageParts(item.messageBot).text"/>
                      <!-- router ตีกลับ :ACCESS_LEVEL_REQUIRED: ⇒ แสดงเป็น alert แทนข้อความดิบ -->
                      <v-alert
                        v-if="getBotMessageParts(item.messageBot).accessRequired"
                        type="warning"
                        density="compact"
                        variant="tonal"
                        class="my-1"
                        style="flex: 1 1 100%;"
                        data-testid="stream-access-denied"
                      >ACCESS_LEVEL_REQUIRED — สิทธิ์ไม่ผ่าน ต้องยืนยันตัวตนเพิ่ม (ลองเลือก Access Level ให้สูงขึ้นแล้วส่งซ้ำ)</v-alert>
                    </div>
                    <div
                      v-if="isQuickReplyVisible(index)"
                      class="stream-quick-reply-row"
                      @click.stop
                    >
                      <button
                        v-for="(reply, quickReplyIndex) in getBotMessageParts(item.messageBot).quickReplies"
                        :key="`${index}-${quickReplyIndex}-${reply}`"
                        type="button"
                        class="stream-quick-reply-pill"
                        :disabled="!isQuickReplyActive(index)"
                        @click.stop="sendQuickReply(reply, index)"
                      >
                        {{ reply }}
                      </button>
                    </div>
                  </div>
                  <!-- Error -->
                  <div v-else style="line-break: anywhere;
                    padding: 16px 20px;    background: rgb(249,249,249);
                    border-radius: 8px; box-shadow: 0 2px 4px #00000024, 0 0 2px #0000001f;
                    font-size: 16px;    font-weight: 400;
                    line-height: 22px;    white-space:  pre-line;   
                    width: fit-content;    float: left; max-width: 65%;">
                    <MarkdownRenderer :content="item.messageBot"/>
                    <span> ...{{ item.status_Process }}</span>
                  </div>

                </v-col>

              </v-row>

            </div>

            <div ref="ChatRef"></div>
            
          </div>




          <!-- <div style="    width: 100%;    display: flex;
    flex-direction: row;    position: sticky;    bottom: 15px;
    background: white;    border-radius:0px 0px 5px 5px;    padding-top: 15px;    padding-right: 10px;
    padding-left: 3px;"> -->

          <div style="width: 100%;display: flex;
            flex-direction: row;position: sticky;
            background: white;padding-top: 5px;">

            <!-- <v-col cols="1" style=" max-width: 5%; text-align: end;    padding-right: 0px;"> -->
            <div style="display: flex; max-width: 50px; text-align: end;justify-content: flex-end; 
              padding-right: 10px;flex-direction: column;gap: 8px;">
                <v-btn variant="text" class="tool-btn" icon style="font-size: 15px; "
                  v-on:click="Clear_listMessage"
                  :style="(listMessage.length > 0 &&
                    (listMessage[listMessage.length - 1].status_Process == 'Process' ||
                      listMessage[listMessage.length - 1].status_Process == 'Send_Message' ||
                      listMessage[listMessage.length - 1].status_Process == 'VoiceStart'

                    )
                    ? 'color:gainsboro;    cursor: unset;' :
                    (listMessage.length == 0 ? 'color:gainsboro;    cursor: unset;' : 'color:#71717A;    cursor: pointer;'))">

                  <v-icon color="orange">mdi-broom</v-icon>
                </v-btn>

                <v-btn variant="text" class="tool-btn" icon style="font-size: 15px; color:#71717A; cursor: pointer;"
                  color="primary" v-on:click="GetTaxState">
                  <v-tooltip activator="parent" location="top">Get Tax State</v-tooltip>
                  <v-icon color="primary">mdi-calculator-variant-outline</v-icon>
                </v-btn>

                <v-btn variant="text" class="tool-btn" icon style="font-size: 15px;" color="primary" :style="(listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process != 'END'
                  && listMessage[listMessage.length - 1].status_Process != 'Stop'
                  && listMessage[listMessage.length - 1].status_Process != 'Error' ? 'color:gainsboro;    cursor: unset;' :
                  'color:#71717A ; cursor: pointer;')" v-on:click="click_music_box()">
                  <v-icon>mdi-folder-music</v-icon>
                </v-btn>
                <input id="inputFileVoid" type="file" @change="Chang_InputFileVoid"
                  style="visibility: hidden; display: contents" accept="audio/wav,audio/mpeg,audio/x-m4a" />

              <div>
                <v-btn variant="text" class="tool-btn" icon style="font-size: 15px;" color="error"
                  v-if="(listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process == 'VoiceStart')"
                  :style="(listMessage.length > 0
                    && listMessage[listMessage.length - 1].status_Process != 'VoiceStart' ? 'color:gainsboro;    cursor: unset;' :
                    'color:#71717A ; cursor: pointer;')" v-on:click="TypeInputAudio = 'M'; Click_StopVoice()">

                  <v-icon>mdi-stop-circle</v-icon>

                </v-btn>
                <v-btn variant="text" class="tool-btn" icon v-else style="font-size: 15px;" color="primary"
                  :style="(listMessage.length > 0
                    && listMessage[listMessage.length - 1].status_Process != 'END'
                    && listMessage[listMessage.length - 1].status_Process != 'Stop'
                    && listMessage[listMessage.length - 1].status_Process != 'Error' ? 'cursor: unset;' :
                    'cursor: pointer;')" v-on:click="click_account_voice">

                  <v-icon>mdi-account-voice</v-icon>

                </v-btn>
              </div>
            </div>

            <!-- #region Chatbox -->
            <div style="width: 100%; padding: 0px; margin: 0;">
              <!-- Image Preview Container -->
              <div v-if="fileDataUrl != null" class="file-preview-container image-preview">
                <div class="preview-content">
                  <img :src="fileDataUrl" alt="img-upload" class="preview-image">
                  <div class="preview-overlay" v-show="loadingImage">
                    <v-progress-circular 
                      indeterminate
                      color="white"
                      size="24"
                      width="3"
                    ></v-progress-circular>
                  </div>
                  <v-btn 
                    v-show="!loadingImage" 
                    icon
                    variant="flat"
                    size="24px"
                    color="error"
                    class="preview-close-btn"
                    @click="ClearImage()"
                  >
                    <v-icon size="16">mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- File Attachment Preview Container -->
              <div v-if="pickedFileType != null" class="file-preview-container file-attachment">
                <div class="file-content">
                  <div class="file-icon-wrapper">
                    <img 
                      :src="pickedFileType" 
                      alt="file-type" 
                      class="file-icon"
                      :class="{ 'file-processing': !uploadFileComplete }"
                    >
                    <v-progress-circular 
                      v-if="!uploadFileComplete" 
                      indeterminate 
                      color="primary" 
                      size="20" 
                      width="2"
                      class="file-progress-overlay"
                    ></v-progress-circular>
                  </div>
                  
                  <div class="file-details">
                    <div class="file-name">{{ pickedFileName }}</div>
                    <div v-if="!uploadFileComplete || (dataAll > 0 && dataUpdate < dataAll)" class="file-progress">
                      <v-progress-linear 
                        :model-value="(dataUpdate / dataAll) * 100"
                        color="primary"
                        height="3"
                        rounded
                      ></v-progress-linear>
                      <span class="progress-text">{{ Math.round((dataUpdate / dataAll) * 100) }}%</span>
                    </div>
                    <div v-else class="file-status">
                      <v-icon size="12" color="success">mdi-check-circle</v-icon>
                      <span>Ready</span>
                    </div>
                  </div>
                  
                  <v-btn 
                    icon
                    variant="flat"
                    size="small"
                    color="error"
                    class="file-close-btn"
                    @click="ClearUploadedFile()"
                  >
                    <v-icon size="16">mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- Enhanced Textarea Container -->
              <div class="textarea-container">
                <v-textarea 
                  ref="RefMessageData" 
                  v-model="messageData" 
                  variant="outlined"
                  :maxlength="maximumChatInput" 
                  clearable 
                  counter 
                  auto-grow
                  placeholder="Type your message here... (Shift + Enter for new line)" 
                  @paste="onPaste"
                  @click:clear="messageData = ''" 
                  @keydown.enter.shift="Key_Ctrl_Flag = true"
                  color="primary"
                  @keyup.enter.shift="Shift_Enter_MessageData"
                  @keydown.enter.exact.prevent="SendOpenAi('Enter'); Key_Ctrl_Flag = false;"
                  class="stream-textarea"
                  rows="3"
                  max-rows="8"
                  style="border-radius: 25px !important;"
                >
                  <template v-slot:append-inner>
                    <div>
                      <!-- Send Button -->
                      <div class="send-button-container">
                        <v-btn 
                          v-if="listMessage.length > 0 && 
                                listMessage[listMessage.length - 1].status_Process !== 'END' && 
                                listMessage[listMessage.length - 1].status_Process !== 'Stop' && 
                                listMessage[listMessage.length - 1].status_Process !== 'Error'"
                          size="small" 
                          variant="flat" 
                          icon
                          class="send-btn"
                          @click="StopMessage"
                          color="error"
                          style="font-size: 20px; background-color: gray; margin-left: 8px; border-radius: 20px;">
                          <v-icon>mdi-stop</v-icon>
                        </v-btn>
                        <v-btn 
                          v-else
                          icon
                          variant="text"
                          size="small"
                          class="send-btn"
                          @click="SendOpenAi('Click')"
                          :disabled="(uploadFileComplete == false && pickedFileType != null) ||
                                    (listMessage.length > 0 && 
                                      listMessage[listMessage.length - 1].status_Process !== 'END' && 
                                      listMessage[listMessage.length - 1].status_Process !== 'Stop' && 
                                      listMessage[listMessage.length - 1].status_Process !== 'Error')"
                          :color="(listMessage.length > 0 &&
                                  listMessage[listMessage.length - 1].status_Process !== 'END' &&
                                  listMessage[listMessage.length - 1].status_Process !== 'Stop' &&
                                  listMessage[listMessage.length - 1].status_Process !== 'Error')
                                  ? 'grey-lighten-2' : 'primary'">
                          <v-icon>mdi-send</v-icon>
                        </v-btn>
                      </div>

                      <!-- Attachment Menu -->
                      <div class="attachment-menu ml-2" v-if="fileDataUrl == null && pickedFileType == null">
                        <v-menu 
                          transition="slide-y-transition" 
                          location="top"
                          offset="8"
                        >
                          <template v-slot:activator="{ props }">
                            <v-btn
                              icon
                              variant="text"
                              size="40"
                              v-bind="props"
                              class="attachment-btn"
                              
                            >
                              <v-icon color="grey-darken-1">mdi-paperclip-plus</v-icon>
                            </v-btn>
                          </template>
                          
                          <v-card class="attachment-menu-card" elevation="8" rounded="lg">
                            <v-list density="compact" class="attachment-list">
                              <v-list-item 
                                v-for="(item, index) in attachItems" 
                                :key="index"
                                class="attachment-list-item" 
                                @click="handleAttachmentItemClick(item.id)"
                              >
                                <template v-slot:prepend>
                                  <div class="attachment-icon-wrapper">
                                    <v-icon :icon="item.icon" size="20"></v-icon>
                                  </div>
                                </template>
                                <v-list-item-title class="attachment-title">
                                  {{ item.title }}
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </v-menu>
                      </div>
                    </div>

                  </template>
                </v-textarea>
              </div>
            </div>
            <!-- #endregion Template -->

            <!-- Hidden File Upload Components -->
            <DragDropFile 
              ref="imageDragDrop" 
              v-show="false" 
              style="display: none !important;" 
              :dialog="true"
              :DragDrop="false" 
              :ShowListFile="false" 
              :IconBtn="true" 
              :allowType="['image/jpeg', 'image/png', 'image/svg+xml']" 
              @filesUploaded="processUploadImage($event)" 
            />
            
            <DragDropFile 
              ref="fileDragDrop" 
              v-show="false" 
              :dialog="true" 
              :DragDrop="false" 
              :ShowListFile="false" 
              :IconBtn="true" 
              :allowType="[
                'text/csv',
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'text/plain',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation'
              ]" 
              @filesUploaded="processUploadFile($event)" 
            />

            <!-- </v-col> -->

          </div>
          <div style="width: 100%; display: flex; justify-content: end; align-items: center;">
            <span style="font-size: 12px;color: #71717A;margin-bottom: 1px;">{{ messageData.length }} / {{ maximumChatInput }}</span>
          </div>
          <span style="font-size: 12px;color: #71717A;margin-bottom: 1px;">AI can make mistakes. Please double-check
            responses.</span>



        </v-col>


      </v-row>
      <div v-if="alertDialog" style="position: fixed; top: 16px; left: 50%; transform: translateX(-50%); z-index: 1000;"
        :class="{ 'fade-in': alertDialog, 'fade-out': !alertDialog }">
        <v-alert color="green" type="success" dismissible @click:close="alertDialog = false">
          The image is downloading...
        </v-alert>
      </div>
      <v-dialog v-model="showImage" max-width="1000">
        <v-card style="
        height: 85vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        box-shadow: none;
        overflow: hidden;
      ">
      <v-img :src="dialogImage" contain style="
          width: 100%;
          height: 100%;
          object-fit: contain;
        " />
        </v-card>
        <div style="position: fixed; bottom: 16px; left: 50%; transform: translateX(-50%);
            display: flex; justify-content: center; gap: 8px; z-index: 1000; opacity: 0; 
            animation: fadeUp 0.3s ease forwards 0.3s;">
          <input type="file" webkitdirectory directory id="folderPicker" style="display: none;">
          
          <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
            <v-icon color="white">mdi-download</v-icon>
          </div>
          <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="showImage = false">
            <v-icon color="white">mdi-close</v-icon>
          </div>
        </div>
      </v-dialog>

      <v-dialog ref="form" v-model="Uploaddialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <p v-if="TypeInputAudio == 'F'" class="headline" style="color: #1d4f81">{{ $t('StreamPopupFileHeader') }}
            </p>
            <p v-else class="headline" style="color: #1d4f81">{{ $t('StreamPopupVoiceHeader') }}</p>


          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-row>

                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete :label="$t('StreamPopuplang')" :items="DDGPTModel" item-title="name"
                      item-value="value" variant="outlined" v-model="LangPop"></v-autocomplete>
                    <!-- {{ $t('StreamPopuplang')  }} -->
                  </v-col>
                  <!-- <v-col cols="12" sm="12" md="6">
                  <v-btn class="text-white mt-3"
                style="margin-left: 1em; border-radius: 8px;  width: 100px"
                @click="ReProcess()"><v-icon >mdi-upload</v-icon>Upload</v-btn>
                </v-col> -->

                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="Uploaddialog = false">{{ $t('close') }}</v-btn>

            <v-btn color="blue-darken-1" v-if="TypeInputAudio == 'M'" variant="text"
              @click="Click_StartVoice(); Uploaddialog = false">{{ $t('StreamPopupRecord') }}</v-btn>
            <v-btn color="blue-darken-1" v-else variant="text" @click="Click_FileButtonVoid(); Uploaddialog = false">{{
              $t('Upload')
            }}</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Private Memory -->

      <v-dialog ref="form" v-model="PrivateMemoryDialog_ListFile" persistent max-width="1050px" scrollable>
        <v-card>
          <v-card-title>
            <v-row style=" padding-top: 5px;">
              <v-col cols="12" sm="6" md="6" style="text-align: start; padding-left: 22px;">
                <p class="headline" style="color: #1d4f81;margin-bottom: 0px;">{{ $t('StreamUploadPrivateMemory') }}</p>
              </v-col>
              <v-col cols="12" sm="6" md="6" style="text-align: end;padding-right: 22px;padding-top: 0px;"
                class="btn_PrivateMemoryDialog_ListFile">
                <v-row>
                  <v-col cols="6" sm="6" md="6" style="padding-left:0px;">
                    <v-btn class="primary text-white mt-3" style="margin-left: 0em"
                      @click="OpenPopup_Private_Memory(null)">
                      <v-icon size="20" style="padding-right: 5px;">mdi-upload</v-icon>
                      <!-- <v-icon size="20" style="padding-right: 5px;">mdi-plus-circle-outline</v-icon> -->
                      Upload</v-btn>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" style="padding-left:0px;">
                    <v-btn class="text-white mt-3" style=" background: #faa91b;"
                      @click="PrivateMemoryDialog_ListFile = false;">Close</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text id="PrivateMemory_ListFile">
            <!-- <v-card-text style="padding-left: 5px;    padding-right: 5px;"> -->
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-data-table class="v_data_table_Private_Memory" :items-per-page="itemsPerPage_ListFilePM"
                  :items-length="searchTotalTable_ListFilePM" :options.sync="options_ListFilePM"
                  :items="dataTable_ListFilePM" :headers="headers_ListFilePM" :loading="loadingTable_ListFilePM"
                  loading-text="Loading...">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td style="width: 90px; text-align: center">
                        {{ item.number }}
                      </td>
                      <td>{{ item.fileName }}</td>
                      <td>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on: menu }">
                            <v-btn icon v-on="{ ...menu }">
                              <v-icon size="22">mdi-dots-horizontal</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="Version(item.fileId)">
                              <v-list-item-title>{{ $t('gpt_model_management_version_history') }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </td>
                      <td style="text-align: center">
                        <v-btn id="OpenPopup_Private_Memory-stream" icon @click="OpenPopup_Private_Memory(item)">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="edit" :src="images.edit" v-bind="props" />
                            </template>
                            <span>edit</span>
                          </v-tooltip>
                        </v-btn>
                        <v-btn id="Delete_ListFilePM_ById_Stream-stream"  icon @click="Delete_ListFilePM_ById_Stream(item.fileId)">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="delete" :src="images.delete" v-bind="props" />
                            </template>
                            <span>delete</span>
                          </v-tooltip>
                        </v-btn>
                        <v-switch style="display: inline-block; 
                          padding-left: 0.5em; 
                          padding-top: 0" @change="PrivateVectorOnOffByFileID(item)" v-model="item.isActive"
                          inset></v-switch>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog ref="form" v-model="PrivateMemoryDialog" persistent max-width="1200px" scrollable>
        <v-card>
          <v-card-title>
            <!-- {{ requestVector }} //  -->
            <p class="headline" style="color: #1d4f81">{{ $t('StreamPrivateMemory') }} {{ requestVector.fileId == null
              ||
              requestVector.fileId == -1 ? $t('StreamPrivateMemoryAdd') : $t('StreamPrivateMemoryEdit') }}</p>
          </v-card-title>
          <v-card-text id="PrivateMemory">
            <v-container>
              <v-form ref="form" lazy-validation>
                <v-row>
                  <!--Document Name-->
                  <v-col cols="12" sm="12" md="2">
                    <!--                       
                    <v-text-field height="68px" :label="'Vector database name'" :disabled="PrivateMemory_Disabled_Name"
                      v-model="KeyTopic" variant="outlined"></v-text-field>  

                    <v-row style="margin-top: 0">
                      <v-col cols="6" style="     padding-top: 0px;padding-right: 0px;">
                        <v-text-field :label="'Top VDB*'" v-model="requestVector.topVDB" clearable variant="outlined"
                          @keypress="isNumberpositive($event)" :rules="[checkValidate()]"></v-text-field>
                      </v-col>

                      <v-col cols="6" style="     padding-top: 0px;padding-right: 0px;">
                        <v-text-field :label="'Cosine'" v-model="requestVector.cosine" clearable variant="outlined"
                          @keypress="isNumber($event)"></v-text-field>
                      </v-col>
                    </v-row> -->
                    <v-text-field @keypress="handleKeypress" :label="$t('StreamFileNamePrivateMemory')"
                      :rules="[checkValidate()]" :disabled="actionEdit" v-model="requestVector.searchVectorDBName2"
                      variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px;" v-bind="props">mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t('_InfoVectorDatabaseName') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <!--Text Replacement-->
                  <v-col cols="12" sm="12" md="3">
                    <v-autocomplete :label="'Text Replacement'" :items="DDGroupReplace" item-title="name" item-value="id"
                      multiple chips deletable-chips clearable variant="outlined" density="compact" v-model="tempgroupReplaceID"><template
                        v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoGroupReplaceText') }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <!--Process type-->
                  <v-col cols="12" sm="12" md="2">
                    <v-select :label="$t('process_type')" :items="modeType" item-title="name" item-value="value" variant="outlined"
                      v-model="requestVector.deleteAll" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoProcess_type') }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <!--Custom Max Character-->
                  <v-col cols="12" sm="12" md="2">
                    <v-text-field :rules="[rules.required]" @keypress="numericKey"
                      :label="$t('_InfoCustomMaxCharacter')" v-model="requestVector.MaxLimitedCharacter" variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoCustomMaxCharacter') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <!--DetectLanguage-->
                  <v-col cols="12" sm="12" md="3">
                    <v-switch v-model="requestVector.DetectLanguage" inset
                      :label="`DetectLanguage : ${requestVector.DetectLanguage ? 'auto' : 'not auto'}`">
                      <template v-slot:label>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <label v-bind="props">{{ `DetectLanguage : ${requestVector.DetectLanguage ? 'auto'
                              : 'not auto'}` }}</label>
                          </template>
                          <span>{{ $t('_InfoDetectLanguage') }}</span>
                        </v-tooltip>
                      </template>
                    </v-switch>
                  </v-col>
                </v-row>
                <v-row style="margin-top: -1rem;">
                  <!--Doctype-->
                  <v-col cols="12" sm="12" md="2">
                    <v-select :rules="[rules.required]" :label="$t('doctype')" :items="datadoctype" item-title="name"
                      item-value="value" v-model="doctype" variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoDoctype') }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <!--Vectortype-->
                  <v-col cols="12" sm="12" md="2">
                    <v-select :rules="[rules.required]" :label="$t('vectortype')" :items="filterdatavectortype"
                      item-title="name" item-value="value" v-model="vectortype" variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoVectortype') }}</span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-col>
                  <!--Type-->
                  <v-col cols="12" sm="12" md="3">
                    <v-autocomplete :rules="[rules.required]" :label="$t('type')" :items="filterDDType" item-title="name"
                      item-value="value" v-model="requestVector.modelType" clearable variant="outlined" density="compact">
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                          </v-list-item-content>
                          <v-tooltip location="right">
                            <template v-slot:activator="{ props }">
                              <v-list-item-icon v-bind="props">
                                <v-icon> mdi-information</v-icon>
                              </v-list-item-icon>
                            </template>
                            <span>
                              <img :src="data.item.image" width="300">
                            </span>
                          </v-tooltip>
                        </template>
                      </template>
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfofillterModelType') }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <!-- <v-col cols="12" sm="12" md="3" v-if="requestVector.modelType != 3"></v-col> -->

                  <v-col cols="12" sm="12" md="2" v-show="requestVector.modelType == 3">
                    <v-text-field :rules="[checkCustomCharacterValidate()]" :label="'Custom Character'"
                      v-model="requestVector.customCharacter" variant="outlined" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" :max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>ADD คือกระบวนการเพิ่มข้อมูลลง Vector, Raplace คือกระบวนการแก้ไขคำตอบ</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-row justify="end">
                    <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end;">
                      <v-btn class="primary text-white mt-3" style="margin-left: 1rem;"
                        @click="TemplateVectorDialog()">Template</v-btn>
                      <DragDropFile :dialog="true" :DragDrop="false" :ShowListFile="false" :accept="accept"
                        :allowType="[]" @filesUploaded="processUpload($event)" />
                    </v-col>
                  </v-row>
                </v-row>
                <v-row style="margin-top: -1rem;">
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field :label="'text_org'" v-model="searchtext_org"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="1">
                    <v-btn fab class="primary text-white mt-3" @click="Search()">
                      <v-icon size="30">mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row justify="end">
                    <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end;">
                      <v-btn class="text-white mt-3"
                        style="margin-left: 1rem; border-radius: 25.342px; background: #9747ff; width: 100px"
                        @click="ReProcess()">REPROCESS</v-btn>
                      <v-btn class="text-white mt-3"
                        style="margin-left: 1rem; border-radius: 25.342px; background: #139fd7" @click="ReFresh()">{{
                          dataUpdate }} of {{ dataAll }}
                        <v-icon>mdi-refresh</v-icon></v-btn>
                      <v-btn class="primary text-white mt-3" style="margin-left: 1rem" @click="AddVectorperChunk()">
                        <v-icon size="20" style="padding-right: 5px">mdi-plus-circle-outline</v-icon>
                        {{ $t('add') }}</v-btn>
                    </v-col>
                  </v-row>
                </v-row>



                <!-- <v-row style="margin-top: 0"> -->
                <!-- <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: left">
                    <v-btn class="text-white mt-3"
                      style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 100px"
                      @click="ReProcess()">REPROCESS</v-btn>
                    <v-btn class="text-white mt-3" style="margin-left: 1em; border-radius: 25.342px; background: #139fd7"
                      @click="ReFresh()">
                      {{ dataUpdate }} of {{ dataAll }}<v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn class="primary text-white mt-3" style="margin-left: 1em" @click="AddVectorperChunk()">
                      <v-icon size="20" style="padding-right: 5px">mdi-plus-circle-outline</v-icon>
                      {{ $t('add') }}</v-btn>


                  </v-col> -->

                <!-- <v-col cols="12" sm="12" md="3" style="display: inline-flex; justify-content: end"> -->
                <!-- <a @click="TemplateVectorDialog"
                      style="margin-top: 1.9rem; padding-left: 1em;padding-right: 1em; font-size: 14px"> Template
                    </a> -->
                <!-- <a @click="TemplateVectorDialog"
                      style="margin-top: 22px; padding-left: 1em;padding-right: 1em; font-size: 14px"> Template
                    </a> -->
                <!-- <v-btn class="primary text-white mt-3" style="margin-left: 1rem;" @click="TemplateVectorDialog()">Template</v-btn> -->

                <!-- <v-switch v-model="requestVector.DetectLanguage" inset
                      :label="`Detect : ${requestVector.DetectLanguage ? 'auto' : 'not auto'}`"></v-switch> -->
                <!-- <DragDropFile :dialog="true" :DragDrop="false" :accept="accept" :ShowListFile="false" :allowType="[
                      // 'text/csv',
                      // 'application/pdf',
                      // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      // 'text/plain',
                      // 'application/msword',
                      // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                      // 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                    ]" @filesUploaded="processUpload($event)" /> -->
                <!-- </v-col> -->

                <!-- <v-col cols="12" sm="12" md="2" style="display: inline-flex; justify-content: end">
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" style="display: inline-flex; justify-content: right;">
                    <v-checkbox v-model="checkBoxShowAllText"
                      :label="`${$t('_ShowAllText')}: ${checkBoxShowAllText ? $t('_ShowAllTextOn') : $t('_ShowAllTextOff')}`"></v-checkbox>
                  </v-col>
                </v-row>
                <v-col cols="12" sm="12" md="2" style="display: inline-flex; justify-content: end"> </v-col>

                <!-- {{ showTable }} -->
                <v-data-table v-show="showTable == true" :items-per-page="itemsPerPage"
                  :items-length="searchTotalTable" v-model:options="options" :items="dataTable" :headers="headers"
                  :loading="loadingTable" loading-text="Loading..." fixed-header mobile-breakpoint="300"
                  class="elevation-1 responsive-table">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td style="text-align:center">
                        {{ item.number }}
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']"
                            v-html="formatText(item.textORG)"> </span>
                        </div>
                      </td>
                      <td>
                        <div class="text-container">
                          <span :class="[item.show ? 'text-content-show' : 'text-content']"
                            v-html="formatText(item.textEN)"> </span>
                          <v-btn icon rounded @click="item.show = !item.show">
                            <v-icon style="color:black;">{{ item.show ? 'mdi-chevron-up' : 'mdi-chevron-down'
                            }}</v-icon>
                          </v-btn>
                        </div>
                      </td>
                      <td style="text-align: center">
                        <v-btn icon @click="EditVectorperChunk(item)" v-if="!item.flagGenerateVector">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="edit" :src="images.edit" v-bind="props"/>
                            </template>
                            <span>edit</span>
                          </v-tooltip>
                        </v-btn>
                        <v-btn icon @click="DeleteById(item.id)">
                          <v-tooltip location="top" :open-delay="500">
                            <template v-slot:activator="{ props }">
                              <img alt="delete" :src="images.delete" v-bind="props"/>
                            </template>
                            <span>delete</span>
                          </v-tooltip>
                        </v-btn>
                        <v-switch style="display: inline-block; 
                          padding-left: 0.5em; 
                          padding-top: 0" @change="VectorOnOff(item)" v-model="item.activeFlag" inset></v-switch>
                      </td>
                    </tr>
                  </template>
                </v-data-table>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-banner>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="error" style="margin-right: 3em; margin-top: 1em"
                          @click="DeleteByName(KeyTopic)" v-if="showTable == true"
                          :disabled="searchTotalTable == 0">{{
                            $t('deleteAll')
                          }}</v-btn>
                        <!-- <v-btn class="text-white mt-3"
                          style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 120px"
                          @click="SaveCosine_TopVDB();">Save & Close</v-btn> -->

                        <!-- <v-btn class="text-white mt-3" v-if="showTable == true"
                          style="margin-left: 1em; border-radius: 25.342px; background: rgb(14, 161, 14); width: 120px"
                          @click="SaveFileName_PrivateMemory">Save  </v-btn>


                          <v-btn class="text-white mt-3" v-if="showTable == true"
                          style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 120px"
                          @click="CloseFileName_PrivateMemory">Close</v-btn> -->

                        <v-btn class="text-white mt-3" v-if="showTable == true"
                          style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 120px"
                          @click="SaveFileName_PrivateMemoryStream">Close</v-btn>
                      </v-card-actions>
                    </v-banner>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <!-- <v-card-actions> 
          </v-card-actions> -->
        </v-card>
      </v-dialog>

      <v-dialog ref="form" v-model="EditVector" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">Edit Vector</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <!-- <v-form ref="form" v-model="valid" lazy-validation> -->
              <v-form ref="form" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea :label="'text_org'" variant="outlined" counter auto-grow rows="15" v-model="Edit.textORG"
                      required></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="closeUploaddialog">{{ $t('close') }}</v-btn>
            <v-btn color="blue-darken-1" variant="text" @click="SaveEdit()">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog ref="form" v-model="AddVector" max-width="800px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">Add Vector</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <!-- <v-form ref="form" v-model="valid" lazy-validation> -->
              <v-form ref="form" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea :label="'text_org'" variant="outlined" counter auto-grow rows="15" v-model="Add.textORG"
                      required></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="closeUploaddialogAdd">{{ $t('close') }}</v-btn>
            <v-btn color="blue-darken-1" variant="text" @click="SaveAdd()">{{ $t('save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-dialog v-model="TemplateVector" max-width="800px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">Template Vector</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-data-table class="v_data_table_Private_Memory" :items="dataTemplate" :headers="headersTemplate"
                loading-text="Loading..." hide-default-footer disable-sort>
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="width: 81px; text-align: center">
                      {{ item.modeType }}
                      <template v-if="item.modeType == 'CustomSplit'">
                        <v-tooltip location="bottom">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-information</v-icon>
                          </template>
                          <span>Template CustomSplit use "||!" Example SplitChunkContent</span>
                        </v-tooltip>
                      </template>
                    </td>
                    <td style="text-align: center" v-if="item.modeType != 'CustomSplit' && item.modeType != 'Article'">
                      <v-btn icon @click="linkDownload(item.modeType, item.CSV)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file</v-icon>
                          </template>
                          <span>{{ item.modeType }} - CSV</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center" v-if="item.modeType != 'CustomSplit' && item.modeType != 'Article'">
                      <v-btn icon @click="linkDownload(item.modeType, item.Excel)"
                        v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-excel</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Excel</span>
                        </v-tooltip>
                      </v-btn>
                      <v-btn icon @click="linkDownload(item.modeType, item.ExcelMultiColumn)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-excel-box</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Excel (Multiple column)</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.PDF)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-pdf-box</v-icon>
                          </template>
                          <span>{{ item.modeType }} - PDF</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.Word)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-word</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Word</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.PowerPoint)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props"> mdi-file-powerpoint</v-icon>
                          </template>
                          <span>{{ item.modeType }} - PowerPoint</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                    <td style="text-align: center"
                      v-if="item.modeType != 'HeaderAllChunk' && item.modeType != 'HeaderFirstChunk'">
                      <v-btn icon @click="linkDownload(item.modeType, item.Text)">
                        <v-tooltip location="top" :open-delay="500">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-file-document</v-icon>
                          </template>
                          <span>{{ item.modeType }} - Text</span>
                        </v-tooltip>
                      </v-btn>
                    </td>
                    <td v-else style="text-align: center">-</td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="TemplateVector = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_version" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">{{ $t('gpt_model_management_version_history') }}</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-data-table :items-per-page="itemsPerPage_version" :items-length="searchTotalTable_version"
                :options.sync="options_version" :items="menus_version" :headers="headers_version_history"
                :footer-props="{ 'items-per-page-options': [5] }">
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="text-align: center">{{ item.version }}</td>
                    <td style="text-align: center">{{ item.createDate }}</td>
                    <td style="text-align: center">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on: menu }">
                          <v-btn icon v-on="{ ...menu }">
                            <v-icon size="22">mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item :key="item.id" @click="changeRestoreNewVersion(item.id, item.fileId)">
                            <v-list-item-title>Restore</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="viewVersion(item.id, item.fileId, item.keytopic)">
                            <v-list-item-title>View</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                    <td style="text-align: center">{{ item.createBy }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="dialog_version = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--dialog view private vector version-->
      <v-dialog v-model="dialog_view_private" width="80vw">
        <v-card>
          <v-card-title>
            <p class="headline" style="color: #1d4f81">{{ $t('gpt_model_management_version_history_detail') }}</p>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-data-table :items-per-page="itemsPerPage" :items-length="searchTotalTable_view_private"
                :options.sync="options_view_private" :items="view_private_version"
                :headers="header_view_private_version" class="elevation-1 responsive-table">
              </v-data-table>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" variant="text" @click="dialog_view_private = false">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="loading" persistent width="300">
        <v-card color="#1976D2">
          <v-card-text class="text-white">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
// import call from "../api/call";
// import enurl from "@/api/environment";


// import axios from 'axios';
// import VueMarkdown from 'vue-markdown-v2';
import Cookies from "js-cookie";
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import MarkdownRenderer from '@/components/MarkedMarkdown.vue'
// import MarkdownIt from '@/components/MarkedMarkdown.vue'
import DragDropFile from '@/components/DragDropFile.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import { isLatestQuickReplyMessage, parseQuickReplyMessage, shouldShowQuickReplyMessage } from '@/utils/chatQuickReplies';
import { DEFAULT_USER_ACCESS_LEVEL, parseAccessLevelMarker } from '@/utils/accessLevel';
import { accessLevelState, ensureAccessLevelsLoaded } from '@/utils/accessLevelStore';
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import group11Img from "@/assets/images/Group 11.svg";
import group12Img from "@/assets/images/Group 12.svg";
import group13Img from "@/assets/images/Group 13.svg";

import csvImg     from '@/assets/images/FileTypes/csv.png';
import excelImg   from '@/assets/images/FileTypes/excel.png';
import pdfImg     from '@/assets/images/FileTypes/pdf.png';
import docImg     from '@/assets/images/FileTypes/doc.png';
import plainImg   from '@/assets/images/FileTypes/plain.png';
import pptImg     from '@/assets/images/FileTypes/ppt.png';
import unknownImg from '@/assets/images/FileTypes/unknown.png';
const API_BASE_URL = import.meta.env?.VITE_APP_API
export default {
  name: "Stream",
  inject: ['flagNav', 'Status_Error', 'User_Id_Show', 'User_Id', 'Time_Delay', 'Flag_Click_History'
  , 'SetPopup', 'NavbarBtnColorTheme', 'ModelFirst', 'TopicName', 'listTopic'
  , 'Click_History_List', 'DeleteTopicStream',  'RenameClick', 'Log_History_TopicID'
  , 'RenameTopicStream', 'keyupKeyRename', 'auth_token', 'KeyTopic'
  , 'TopicModelID', 'TopicModelID_long', 'StatusKeyRename', 'GetModelFirst_Value'
  , 'IsAllowImage', 'FileUploadLimit', 'IsChainMassage'
  , 'Log_History_ID', 'Log_History_Take', 'GetModelFirst','FontColorTitle','SubNavbarBackGround'],
  components: {
    // VueMarkdown, 
    DragDropFile, 
    MarkdownRenderer,
    StatusIndicator
  },
  data: () => ({
    maximumChatInput : 200000,
    showImage: false,
    dialogImage: '',
    GetLogStreamStart_Flag: true,

    DataLog_Data: "",

    roleId: Cookies.get('roleId'),

    messageImage: "",
    Flag_Start: false,

    LastScrollTop: null,
    Loading_History_Status: false,


    Topic_STATUS: false,

    LOG_STATUS: false,
    // url: enurl.apiUrl, 

    TimeOutStop: null,

    // 5 s
    TimeoutFirst: 5000,
    //Timeout: 60000,
    // 10 s
    // Timeout: 10000,

    // 7 s
    Timeout: 7000,

    // Timeout: 10000,
    SpeechRecognizer: null,

    TypeInputAudio: "",
    Uploaddialog: false,


    LangPop: "th-TH",
    DDGPTModel: [{ name: "TH", value: "th-TH" }, { name: "EN", value: "en-US" }],



    anchorAttrs: {
      target: '_blank',
      rel: 'noopener noreferrer nofollow'
    },

    DataLog: {
      Prompt: "",
      Vector: "",
      ReplySQL: "",
      ReplyDataSelect: "",
      Memory: "",
      Translate: "",
      FlowActionIntent: "",
      GPT_Model: {
        ModelID: "",
        ModelName: "",
        Provider: "",
        Model: "",
        Extension: "",
        Description: "",
        promptTemplate: "",
        gender: "",
        vectordbName: "",
        TopVDB: "",
        internet: "",
        feedback: "",
        HistoryCount: "",
        HistoryMinute: "",
        temperature: "",
        top_p: "",
        frequency_penalty: "",
        presence_penalty: "",
        Stop: "",
        max_tokens: "",
        IsStream: "",
        EndpointURL: "",
      },
      Text: "",
      TextVector: "",
      VectorCoise: "",
      Private_Memory: ""
    },

    point: 0,
    Key_Ctrl_Flag: false,
    Stop_Flag: false,
    StopForChain: false,
    Axios_Controller: [],
    Axios_ControllerAduio: null,

    listMessage: [],
    messageData: "",
    consumedQuickReplyMessage: null,
    pendingContinueQuestion: null,

    CountScroll: 0,
    MaxCountScroll: 15,
    messageRes: [],
    Count_messageRes: [],
    StatusPro: false,
    // messageRun: "",

    auth_token: "",
    // ModelFirst: "-",

    PrivateMemoryDialog_ListFile: false,
    PrivateMemoryDialog: false,
    PrivateMemory_Disabled_Name: true,

    Axios_VECTOR: null,
    sortBy: [],
    sortDesc: [],

    isSearch: false,
    images: {
      edit: editImg,
      delete: deleteImg,
    },

    AddVector: false,
    flagNew: false,
    Add: {
      id: null,
      textORG: null,
    },
    totalTable: 0,

    loadingTable: false,
    showTable: true,

    options: { "page": 1, "itemsPerPage": 10, "sortBy": [], "sortDesc": [false], "groupBy": [], "groupDesc": [], "mustSort": false, "multiSort": false },
    dataTable: [],
    searchTotalTable: 0,
    itemsPerPage: 10,

    // VectorDBName: "",
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    imageData: null,
    TemplateVector: false,
    tempgroupReplaceID: null,
    pickedFileType: null,
    pickedFileName: null,
    DDGroupReplace: [],
    DDType: [
      {
        name: 'General',
        value: 1,
        image: group11Img
      },
      {
        name: 'MaxCharacter',
        value: 2,
        image: group12Img
      },
      {
        name: 'CustomSplit',
        value: 3,
        image: group13Img
      },
      {
        name: 'Article',
        value: 4,
        image: group13Img
      },
      {
        name: 'HeaderAllChunk',
        value: 5,
        image: group11Img
      },
      {
        name: 'HeaderFirstChunk',
        value: 6,
        image: group12Img
      },
      {
        name: 'WordImage',
        value: 7,
        image: group12Img
      },
      {
        name: 'PDFImage',
        value: 8,
        image: group12Img
      },
    ],
    datadoctype: [
      { name: 'CSV', value: 1 },
      { name: 'Excel', value: 2 },
      { name: 'PDF', value: 3 },
      { name: 'Word', value: 4 },
      { name: 'Text', value: 5 },
      { name: 'PowerPoint', value: 6 },
    ],
    datavectortype: [
      { name: 'General', value: 1 },
      { name: 'Article', value: 2 },
      { name: 'PriceList', value: 3 },
    ],
    dataTemplate: [
      {
        modeType: 'General',
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: 'MaxCharacter',
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: 'CustomSplit',
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: 'Article',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'HeaderAllChunk',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
      {
        modeType: 'HeaderFirstChunk',
        CSV: 'CSV',
        Excel: 'Excel',
        ExcelMultiColumn: 'ExcelMultiColumn',
        PDF: 'PDF',
        Word: 'Word',
        Text: 'Text',
        PowerPoint: 'PowerPoint',
      },
    ],
    rules: {
      required: (value) => !!value || 'Required.',
      // required2 : this.vectornameDuplicate || 'dup' 
    },
    VectorDBNameDuplicate: '',
    doctype: null,
    vectortype: null,
    filterdatavectortype: [],
    filterDDType: [],
    accept: '',
    searchtext_org: null,
    actionEdit: false,
    modelType: null,
    MaxLimitedCharacter: null,
    showAllText: false,
    checkBoxShowAllText: false,
    uploadFileComplete: false,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: false,
      groupReplaceID: null,
      customCharacter: null,
      DetectLanguage: true,
      USER_CHANNEL: null,
      TopicID: null,
      topVDB: 3,
      // cosine: null,
      cosine: -1,
      //fileName: "",
      searchVectorDBName2: "",
      fileId: -1,
      MaxLimitedCharacter: null,
    },
    requestUpload: {
      entity: null,
      USER_CHANNEL: null
    },
    modeType: [
      {
        name: 'Add',
        value: false,
      },
      {
        name: 'Replace',
        value: true,
      },
    ],
    EditVector: false,
    Edit: {
      id: null,
      textORG: null,
    },

    totalTable_ListFilePM: 0,
    isSearch_ListFilePM: false,
    loadingTable_ListFilePM: false,
    sortBy_ListFilePM: [],
    sortDesc_ListFilePM: [],
    options_ListFilePM: {},
    dataTable_ListFilePM: [],
    searchTotalTable_ListFilePM: 0,
    itemsPerPage_ListFilePM: 10,
    showHelp: false,
    today: null,
    allAttachItems: [
      { id: 'images', title: 'Images', icon: 'mdi-image' },
      { id: 'files', title: 'Files', icon: 'mdi-paperclip' }
    ],
    dialog_version: false,
    options_version: {},
    itemsPerPage_version: 5,
    menus_version: [],
    searchTotalTable_version: 0,
    totalTable_version: 0,
    fileID: null,
    loading: false,
    ImageURL: null,
    fileDataUrl: null,
    loadingImage: false,
    SessionID: null,
    //dialog view private
    dialog_view_private: false,
    searchTotalTable_view_private: 0,
    totalTable_view_private: 0,
    options_view_private: { "sortBy": [null], "sortDesc": [null] },
    view_private_version: [],
    privateID: null,
    temKeytopic: null,
    flagTopHistory: false,
    alertDialog: false,
    // Status Indicator
    hasStatusUpdates: false,
    savedStatusList: [],  // เก็บ status list เพื่อแสดงหลังจบ
    savedStatusCompleted: false,  // เก็บ state ว่าจบแล้ว
    // Access Level จำลองของผู้ใช้ (ส่งเป็น message.accessLevel — server เชื่อเฉพาะเส้น GptStreamPOST ของ admin)
    AccessLevel: DEFAULT_USER_ACCESS_LEVEL,
  }),

  watch: {

    User_Id_Show: function () {
      var that = this;
      if (that.Flag_Start) {

        that.User_Id_Show = (that.User_Id_Show == null ? '' : that.User_Id_Show);
        that.User_Id = (that.User_Id == null ? '' : that.User_Id);
        if (that.User_Id_Show != null && that.User_Id_Show != "" && that.User_Id_Show.replace(/ /g, '') != "") {

          that.User_Id = that.User_Id_Show;

        }
        else if (that.User_Id_Show.replace(/ /g, '') == "" && that.User_Id.split('-').length == 6) {
          console.log("User_Id_Show : " + that.User_Id_Show + " ,User_Id-length : " + that.User_Id.split('-').length);
        }
        else {
          that.User_Id = that.GetUuidv4_Fun_User_Id_Null();
        }
      }
      else {
        // that.Flag_Start = true;
      }
    },

    User_Id: function () {
      var that = this;
      // console.log(newValue)
      // alert("DD")

      if (that.Flag_Start) {
        // that.listMessage = [];
        // if (that.Log_History_TopicID != -1) {
        that.Log_History_TopicID = -1;
        that.TopicName = "";
        // that.TopicModelID = -1;
        that.TopicModelID = "";
        that.KeyTopic = "";

        that.TopicModelID_long = -1;
        that.Chang_History();
        // that.GetHistoryStream("Start");
        //  that.GetTopicStream("ChangHistory");
        // }

        // that.GetHistoryStream("Start");

        that.GetLogStreamStart_Flag = true;
        that.GetTopicStream("Start");
        // that.GetModelFirst(null);

        that.GetModelFirst_Value(null);
      }
      else {
        that.Flag_Start = true;
      }
    },
    /*
    "$parent.$parent.$parent.Flag_Click_Rename": function () {
      var that = this;

      that.GetTopicStream("ChangHistory");


    },
*/
    Flag_Click_History: function () {
      var that = this;
      that.Chang_History();
      if (that.Log_History_TopicID != -1) {
        that.GetTopicStream("ChangHistory");
      }
    },
    KeyTopic: function () {
      var that = this;

      that.$nextTick(function () {
        that.ClearValuePrivate_Memory();
        /*
      if (that.KeyTopic != "" && that.KeyTopic != null) {

          that.GetByVector();
      }
      */
      });
    },
    options_ListFilePM: {
      handler() {
        // this.GetByVector();
        this.GetListFile_PrivateMemoryStream("");
      },
      deep: true,
    },
    options: {
      handler() {
        //this.ReFresh();
        this.GetByVector();
      },
      deep: true,
    },
    requestVector: {
      handler(newVal) {
        if (newVal.modelType != 3) {
          this.requestVector.customCharacter = null;
        }
      },
      deep: true,
    },
    doctype: {
      handler(val) {
        let self = this;
        self.vectortype = null;
        self.requestVector.customCharacter = null;
        self.filterDDType = [],
          self.filterdatavectortype = [];
        if (val == 1 || val == 2) {
          self.filterdatavectortype = self.datavectortype.filter((e) => e.value != 2);
        } else {
          self.filterdatavectortype = self.datavectortype.filter((e) => e.value != 3);
        }
        self.setTypeFile(val);
      },
    },
    vectortype: {
      handler(val) {
        let self = this;
        self.filterDDType = [];
        self.requestVector.customCharacter = null;
        if (val == 2) {
          self.filterDDType = self.DDType.filter((e) => e.value == 4);
        } else if (val == 3 && (self.doctype == 1 || self.doctype == 2)) {
          self.filterDDType = self.DDType.filter((e) => e.value == 5 || e.value == 6);
        } else {
          if (self.doctype == 4) {
            self.filterDDType = self.DDType.filter((e) => e.value == 1 || e.value == 2 || e.value == 3 || e.value == 7);
          } else if (self.doctype == 3) {
            self.filterDDType = self.DDType.filter((e) => e.value == 1 || e.value == 2 || e.value == 3 || e.value == 8);
          } else {
            self.filterDDType = self.DDType.filter((e) => e.value == 1 || e.value == 2 || e.value == 3);
          }
        }
        self.requestVector.modelType = null;
      },
    },
    options_version: {
      handler() {
        this.Version(this.fileID);
      },
      deep: true,
    },
    options_view_private: {
      handler() {
        this.viewVersion(this.privateID, this.fileID, this.temKeytopic);
      },
      deep: true,
    },
    checkBoxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    }
  },

  computed: {
    // ตัวเลือก Access Level จำลอง = ladder ปัจจุบันจาก store (reactive หลังโหลด GET api/v1/AccessLevel, #914)
    accessLevelOptions() {
      return accessLevelState.options;
    },
    attachItems() {
      if (!this.IsAllowImage) {
        return this.allAttachItems.filter(item => item.id === 'files');
      }
      return this.allAttachItems;
    },
    headers_ListFilePM() {
      return [
        { text: this.$t('no'), align: 'center', sortable: false, },
        { text: this.$t('StreamFileNamePrivateMemory'), value: 'fileName', align: 'center', sortable: true },
        { text: ' ', value: ' ', align: 'center', sortable: false },
        { text: this.$t('manage'), align: 'center', sortable: false },
      ];
    },

    headers() {
      return [
        {
          text: this.$t('no'),
          align: 'center',
          sortable: false,
          width: this.$vuetify.breakpoint.smAndUp ? '60px' : '30px',
        },
        { text: 'text_org', value: 'TextORG', align: 'center', width: this.$vuetify.breakpoint.smAndUp ? '40%' : '300px' },
        { text: 'text_en', value: 'TextEN', align: 'center', width: this.$vuetify.breakpoint.smAndUp ? '40%' : '300px' },
        { text: this.$t('manage'), align: 'center', sortable: false, width: this.$vuetify.breakpoint.smAndUp ? '15%' : 'auto' },
      ];
    },

    headersTemplate() {
      return [
        { text: 'Type', align: 'center', width: '25%' },
        { text: 'CSV', align: 'center' },
        { text: 'Excel', align: 'center' },
        { text: 'PDF', align: 'center' },
        { text: 'Word', align: 'center', },
        { text: 'PowerPoint', align: 'center' },
        { text: 'Text', align: 'center' },
      ];
    },

    headers_version_history() {
      return [
        { text: 'Version', align: 'center', sortable: false, width: '95px' },
        { text: 'Modified', align: 'center', sortable: false },
        { text: ' ', align: 'center', sortable: false },
        { text: 'Modified By', align: 'center', sortable: false },
      ];
    },

    header_view_private_version() {
      return [
        { text: this.$t('no'), value: 'number', align: 'center', justify: 'center', sortable: false, width: '100px' },
        { text: 'text_org', value: 'textORG', align: 'center', sortable: true, },
        { text: 'text_en', value: 'textEN', align: 'center', sortable: true, },
      ];
    },
  },

  methods: {
    // Status Indicator event handler
    onStatusUpdate(status) {
      console.log('AI Status:', status.message);
      // Mark that we have status updates - hide the fallback Finding Answer box
      this.hasStatusUpdates = true;
      
      // Save status list directly from event (not from ref - ref may be unmounted)
      if (status.statusList && status.statusList.length > 0) {
        this.savedStatusList = [...status.statusList];
        this.savedStatusCompleted = status.isCompleted || false;
      }
    },
    getBotMessageParts(message) {
      // ตัด marker :ACCESS_LEVEL_REQUIRED: ออกก่อน แล้วค่อยแยก quick reply จากข้อความที่เหลือ
      const marker = parseAccessLevelMarker(message);
      const parts = parseQuickReplyMessage(marker.text);
      return { ...parts, accessRequired: marker.accessRequired };
    },
    GetTaxState() {
      let that = this;
      that.GetDateTime();
      // show a running bot bubble (StatusIndicator + "Finding answer..." animation)
      // while the tax state is being fetched, mirroring a normal message send.
      const processingIndex = that._startTaxStateProcessing();
      // Tax Planning V2 — the same state read the mobile app makes (V1 endpoint left in call.js)
      that.$call.GetTaxStatePlaygroundV2(
        { userId: that.User_Id, lang: 'TH' },
        (response) => {
          if (response && response.status == 0 && response.data
            && response.data.nextQuestion && response.data.nextQuestion.questionTextTh) {
            const q = response.data.nextQuestion.questionTextTh;
            that._finishTaxStateBubble(processingIndex, q);
            // store the CLEAN question text (|quickReply| marker stripped) so it
            // rides the next user message as continueQuestion.
            that.pendingContinueQuestion = that.getBotMessageParts(q).text;
          } else {
            // success but no question (e.g. no active tax year / config not ready) →
            // don't leave the button silent.
            that._finishTaxStateBubble(processingIndex, 'ยังไม่มีคำถามภาษีให้แสดง — ตรวจสอบว่ามีปีภาษีที่เปิดใช้งาน และตั้ง flowGroupID ของโมเดลเป็น Tax Planning flow');
          }
        },
        (err) => {
          console.error('GetTaxState error', err);
          that._finishTaxStateBubble(processingIndex, 'ดึงสถานะ Tax ไม่สำเร็จ — ตรวจสอบ User ID และการเชื่อมต่อ');
        }
      );
    },
    // push a bot-only "running" bubble (status_Process 'Process') so the same
    // StatusIndicator / "Finding answer..." loading animation used for a normal
    // message shows while GetTaxState waits for the API. Returns its index.
    _startTaxStateProcessing() {
      let that = this;
      // reset the status indicator so the fallback "Finding answer..." box shows
      that.hasStatusUpdates = false;
      that.savedStatusList = [];
      that.savedStatusCompleted = false;
      that.listMessage.push({
        messageUser: '',
        messageBot: '',
        status_Process: 'Process',
        requestTime: that.today,
        responseTime: null,
      });
      const idx = that.listMessage.length - 1;
      // keep messageRes/Count_messageRes parallel to listMessage (see _pushTaxStateBubble)
      that.messageRes[idx] = "";
      that.Count_messageRes[idx] = 0;
      setTimeout(() => {
        that.CountScroll = that.MaxCountScroll;
        that.ChatRef_ScrollIntoView();
      }, 5);
      return idx;
    },
    // finalize the running bubble in place with the resolved text.
    _finishTaxStateBubble(index, text) {
      let that = this;
      const item = that.listMessage[index];
      if (item && item.status_Process === 'Process') {
        item.messageBot = text;
        item.status_Process = 'END';
        item.responseTime = that.today;
        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);
      } else {
        // the running bubble was cleared/replaced — fall back to a fresh bubble.
        that._pushTaxStateBubble(text);
      }
    },
    // push a bot-only bubble into the chat (used by GetTaxState). Keeps
    // messageRes/Count_messageRes parallel to listMessage so the SendOpenAi
    // head-of-function flush reads this item's own (empty) slot instead of
    // clobbering the injected bubble with the previous message's accumulator.
    _pushTaxStateBubble(text) {
      let that = this;
      that.listMessage.push({
        messageUser: '',
        messageBot: text,
        status_Process: 'END',
        requestTime: that.today,
        responseTime: that.today,
      });
      that.messageRes[that.listMessage.length - 1] = "";
      that.Count_messageRes[that.listMessage.length - 1] = 0;
      setTimeout(() => {
        that.CountScroll = that.MaxCountScroll;
        that.ChatRef_ScrollIntoView();
      }, 5);
    },
    isQuickReplyVisible(index) {
      return this.isQuickReplyActive(index) &&
        shouldShowQuickReplyMessage(this.listMessage, index, this.consumedQuickReplyMessage);
    },
    isQuickReplyActive(index) {
      const item = this.listMessage[index];
      const lastMessage = this.listMessage[this.listMessage.length - 1];

      if (!item || !isLatestQuickReplyMessage(this.listMessage, index)) {
        return false;
      }

      if (this.uploadFileComplete === false && this.pickedFileType != null) {
        return false;
      }

      if (lastMessage &&
        lastMessage.status_Process !== 'END' &&
        lastMessage.status_Process !== 'Stop' &&
        lastMessage.status_Process !== 'Error') {
        return false;
      }

      return item.status_Process === 'END' ||
        item.status_Process === 'Stop' ||
        item.status_Process === 'Error';
    },
    sendQuickReply(reply, index) {
      if (!this.isQuickReplyVisible(index)) {
        return;
      }

      this.consumedQuickReplyMessage = this.listMessage[index];
      this.messageData = reply;
      this.$nextTick(() => {
        this.SendOpenAi('Click');
      });
    },
    blockNegative(e) {
      if (e.key === '-' || e.key === 'e' || e.key === '+') {
        e.preventDefault();
      }
    },
    handleAttachmentItemClick(itemId) {
      switch (itemId) {
        case 'images':
          // Trigger the image DragDropFile component
          if (this.$refs.imageDragDrop) {
            this.$refs.imageDragDrop.$el.querySelector('input[type="file"]')?.click();
          }
          break;
        case 'files':
          // Trigger the file DragDropFile component
          if (this.$refs.fileDragDrop) {
            this.$refs.fileDragDrop.$el.querySelector('input[type="file"]')?.click();
          }
          break;
        default:
          console.warn('Unknown attachment type:', itemId);
      }
    },
    processUploadFile(files) {

      if (files.length === 0) {
        return;
      }
      let fileUploadSizeLimit = 4 * 1024 * 1024; // 4 MB
      if (files[0].size > fileUploadSizeLimit) {
        this.$swal.fire({
          icon: 'error',
          title: `ไฟล์มีขนาดใหญ่เกิน 4 MB`,
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      this.ClearValuePrivate_Memory();
      if (this.KeyTopic == null) {
        this.KeyTopic = this.GetUuidv4_Fun();
      }
      this.requestVector = {
        modelType: null,
        modelId: null,
        vectordbName: null,
        entity: null,
        deleteAll: false,
        groupReplaceID: null,
        customCharacter: null,
        DetectLanguage: true,
        USER_CHANNEL: null,
        TopicID: null,
        // topVDB: null,
        topVDB: 3,
        // cosine: null,
        cosine: -1,
        // fileName: item.fileName,
        fileId: -1,
        MaxLimitedCharacter: null
      }

      this.requestVector.searchVectorDBName2 = "";
      this.actionEdit = true;
      this.searchtext_org = null;

      // Determine file type based on MIME type
      let documentType = 1; // Default to CSV
      const file = files[0];
      const mimeType = file.type;

      // Map MIME types to document types
      if (mimeType === 'text/csv') {
        documentType = 1; // CSV
      } else if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        mimeType === 'application/vnd.ms-excel') {
        documentType = 2; // Excel
      } else if (mimeType === 'application/pdf') {
        documentType = 3; // PDF
      } else if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        mimeType === 'application/msword') {
        documentType = 4; // Word
      } else if (mimeType === 'text/plain') {
        documentType = 5; // Text
      } else if (mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
        mimeType === 'application/vnd.ms-powerpoint') {
        documentType = 6; // PowerPoint
      } else {
        documentType = 7; // Unknown
      }

      this.requestVector.fileId - 1;
      this.requestVector.MaxLimitedCharacter = 5500;
      this.requestVector.doctype = documentType;
      this.requestVector.vectortype = 1;
      this.requestVector.modelType = 1;

      this.files = files;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        const formDataDoc = new FormData();
        formDataDoc.append('entity', this.files[0]);
        this.uploadedFiles = this.files;
        this.requestVector.entity = formDataDoc;
        this.pickedFileName = this.files[0].name;
        this.pickedFileType = this.GetFileTypeImg(documentType);
        this.SaveFile();
      };
    },
    GetFileTypeImg(documentType) {
      switch (documentType) {
        case 1: return csvImg;
        case 2: return excelImg;
        case 3: return pdfImg;
        case 4: return docImg;
        case 5: return plainImg;
        case 6: return pptImg;
        default: return unknownImg;
      }
    },
    ClearUploadedFile() {
      let self = this;
      self.pickedFileType = null;
      self.pickedFileName = null;
      self.requestVector.entity = null;
      self.uploadFileComplete = false;
      self.uploadedFiles = [];
      self.files = [];
      self.dataAll = 0;
      self.dataUpdate = 0;
      self.fileID = -1;
    },
    botMessageClick(e) {
      const imageRegex = /!\[.*?\]\((.*?)\)/;
      const match = e.match(imageRegex);
      if (match) {
        this.dialogImage = match[1]; // extracted URL
        this.showImage = true;
      }
    },
    downloadImage() {
      let self = this;
      if (!this.dialogImage) return;
      self.alertDialog = true;
      this.closeDownloadDialog();
      self.$call.DownloadChatImage(
        this.dialogImage,
        null,
        async (dataResponse) => {
          const blob = new Blob([dataResponse], { type: "image/png" });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            const link = document.createElement("a");
            link.href = reader.result; // ใช้ Data URL
            link.download = "downloaded-image.png";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          };
          self.dialog_version = false;
          self.loading = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
        }
      );
    },
    closeImage() {
      this.showImage = false;
      this.dialogImage = '';
    },
    closeDownloadDialog() {
      setTimeout(() => {
        this.alertDialog = false;
      }, 3000);
    },
    onPaste(event) {
      if (!this.IsAllowImage)
        return

      const item = event.clipboardData.items[0]; // เอาเฉพาะ index แรก

      if (item && item.type.startsWith('image')) {

        const file = item.getAsFile();

        const filesArray = [file];
        this.ValidateImage(filesArray);
        const reader = new FileReader();

        reader.onload = (e) => {
          this.fileDataUrl = e.target.result;
          this.ValidateImage(filesArray);
          this.UploadImage()
        };

        reader.readAsDataURL(file);
        event.preventDefault(); // ป้องกันการวางค่าอื่น ๆ
      } else {
        console.log('Not an image or unsupported content');
      }
    },
    PrivateVectorOnOffByFileID(item) {
      let self = this;
      var titleAlert = item.isActive ? this.$t('confirmOn') : this.$t('confirmOff');
      var textAlert = item.isActive ? this.$t('confirmOnVectorName') : this.$t('confirmOffVectorName');
      self.$swal
        .fire({
          title: titleAlert,
          text: textAlert,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              activeFlag: item.isActive,
            };
            self.dialog = true;
            try {
              self.$call.PrivateVectorOnOffByFileID_Stream(
                temp,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    // self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  item.isActive = !item.isActive;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, 'DeleteGroup');
            }
          } else {
            item.isActive = !item.isActive;
          }
        });
    },
    VectorOnOff(item) {
      let self = this;
      var titleAlert = item.activeFlag ? this.$t('confirmOn') : this.$t('confirmOff');
      var textAlert = item.activeFlag ? this.$t('confirmOnVectorName') : this.$t('confirmOffVectorName');
      self.$swal
        .fire({
          title: titleAlert,
          text: textAlert,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              id: item.id,
              activeFlag: item.activeFlag,
            };
            self.dialog = true;
            try {
              self.$call.PrivateVectorOnOff_Stream(
                temp,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    // self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  item.activeFlag = !item.activeFlag;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, 'DeleteGroup');
            }
          } else {
            item.activeFlag = !item.activeFlag;
          }
        });
    },
    async changeRestoreNewVersion(id, fileId) {
      let self = this;
      self.loading = true;
      let req = {
        ID: id,
        fileId: fileId,
      };
      self.$call.SaveReStorePrivateVector_Stream(
        req,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.GetListFile_PrivateMemoryStream("OpenPopPrivateMemoryDialog_ListFile");
          }
          self.dialog_version = false;
          self.loading = false;
          return null;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Version(fileId) {
      let self = this;
      self.loading = true;
      self.fileID = fileId;

      if (self.dialog_version == false) {
        this.options_version.page = 1;
      }

      self.dialog_version = true;
      // self.menus_modelid_version = modelId;
      // self.menus_modeliddisplay_version = modelIDGroup;

      const { page } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: 5,
        fileId: fileId,
      };

      self.$call.GetTablePrivateVectorVersion_Stream(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.menus_version = dataResponse.data.data;
            self.searchTotalTable_version = dataResponse.data.total;
            self.totalTable_version = dataResponse.data.total;
          } else {
            self.menus_version = [];
            self.searchTotalTable_version = 0;
            self.totalTable_version = 0;
          }
          self.loading = false;
          // self.isSearch = false;
          // self.isFirst = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    async viewVersion(id, fileId, keytopic) {
      let self = this;
      self.dialog_view_private = true;
      self.loading = true;
      self.privateID = id;
      self.fileID = fileId;
      self.temKeytopic = keytopic;
      const { page, itemsPerPage } = self.options_view_private;
      self.sortBy = self.options_view_private.sortBy.length == 0 ? null : self.options_view_private.sortBy[0];
      self.sortDesc = self.options_view_private.sortDesc.length == 0 ? null : self.options_view_private.sortDesc[0];

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : null,
        id: id,
        FileId: fileId,
        name: keytopic,
        text_org: null,
        sortDesc: self.sortDesc,
        sortBy: self.sortBy,
      }
      await self.$call.ReFreshPrivateVector_Stream(
        temp,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.view_private_version = dataResponse.data.table.data;
            self.searchTotalTable_view_private = dataResponse.data.table.total;
            self.totalTable_view_private = dataResponse.data.table.total;
          } else {
            self.view_private_version = [];
            self.searchTotalTable_view_private = 0;
            self.totalTable_view_private = 0;
          }
          self.isSearch = false;
          self.loading = false;
        },
        (errorResource) => {
          self.loading = true;
          self.dialog_view_private = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },

    OpenPopup_Private_Memory(item) {
      var that = this;
      that.ClearValuePrivate_Memory();
      if (item == null) {
        that.requestVector = {
          modelType: null,
          modelId: null,
          vectordbName: null,
          entity: null,
          deleteAll: false,
          groupReplaceID: null,
          customCharacter: null,
          DetectLanguage: true,
          USER_CHANNEL: null,
          TopicID: null,
          topVDB: 3,
          // cosine: null,
          cosine: -1,
          //fileName: "",
          searchVectorDBName2: "",
          fileId: -1,
          MaxLimitedCharacter: null,
        }
        that.requestVector.MaxLimitedCharacter = that.MaxLimitedCharacter;
        that.actionEdit = false;
        that.requestVector.modelType = null;
        that.searchtext_org = null;
        // that.requestVector = {
        //   modelType: null,
        //   modelId: null,
        //   vectordbName: null,
        //   entity: null,
        //   deleteAll: false,
        //   groupReplaceID: null,
        //   customCharacter: null,
        //   DetectLanguage: true,
        //   USER_CHANNEL: null,
        //   TopicID: null,
        //   // topVDB: null,
        //   topVDB: 3,
        //   // cosine: null,
        //   cosine: -1,
        //   fileName: "",
        //   fileId: -1
        // }

        that.dataTable = [];
        that.searchTotalTable = 0;
        that.totalTable = 0;
        that.actionEdit = false;


        that.loadingTable = false;
        that.isSearch = false;
        that.isFirst = false;
        that.showTable = true;


      }
      else {
        that.requestVector = {
          modelType: null,
          modelId: null,
          vectordbName: null,
          entity: null,
          deleteAll: false,
          groupReplaceID: null,
          customCharacter: null,
          DetectLanguage: true,
          USER_CHANNEL: null,
          TopicID: null,
          // topVDB: null,
          topVDB: 3,
          // cosine: null,
          cosine: -1,
          // fileName: item.fileName,
          fileId: item.fileId,
          MaxLimitedCharacter: null
        }

        that.requestVector.searchVectorDBName2 = item.fileName;
        that.actionEdit = true;
        that.searchtext_org = null;
        //that.ClearValuePrivate_Memory();
        that.ReFresh();
        that.GetByVector();

      }
      that.PrivateMemoryDialog = true;
    },

    Click_Private_Memory() {
      var that = this;
      if ((that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process != 'END'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Stop'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Error')) {
        return;
      }
      else {
        //that.VectorDBName = that.GetUuidv4_Fun();
        // that.VectorDBName = that.GetUuidv4_Fun();

        // if (that.KeyTopic == null || that.KeyTopic == "" || that.Log_History_TopicID == -1) {
        // if (that.KeyTopic == null || that.KeyTopic == "")
        if (that.KeyTopic == null) {
          that.KeyTopic = that.GetUuidv4_Fun();
        }

        that.GetListFile_PrivateMemoryStream("OpenPopPrivateMemoryDialog_ListFile");
        //  that.PrivateMemoryDialog = true;
        // that.PrivateMemoryDialog_ListFile = true;

      }
    },
    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F]+$/;

      if (!validCharactersRegex.test(String.fromCharCode(charCode))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    GetMaxLimitedCharacter() {
      let self = this;
      self.dialog = true;
      self.$call.GetMaxLimitedCharacter(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.MaxLimitedCharacter = dataResponse.data;
          } else {
            self.MaxLimitedCharacter = self.requestVector.MaxLimitedCharacter;
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    formatText(text) {
      // แปลงช่องว่างเป็น &nbsp; เพื่อให้รักษาช่องว่างได้
      return text.replace(/ /g, '&nbsp;');
    },
    checkCustomCharacterValidate() {
      if (this.requestVector.modelType == 3 && (this.requestVector.customCharacter == '' || this.requestVector.customCharacter == null)) {
        return "Required.";
      } else {
        this.customCharacter = null;
      }
      return true;
    },

    TemplateVectorDialog() {
      let self = this;
      self.TemplateVector = true;
    },
    linkDownload(modelType, filename) {
      let self = this;
      let req = {
        modelType: modelType,
        filename: filename
      }
      self.$call.DownloadTemplateVector_Stream(
        req,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `Template_${modelType}_${filename}${self.findTypeName(filename)}`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.TemplateVector = false;
        },
        (errorResource) => {
          self.TemplateVector = false;
          console.error(errorResource);
        }
      );
    },
    findTypeName(filename) {
      let type = ""
      switch (filename) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },
    setTypeFile(val) {
      let self = this;
      switch (val) {
        case 1:
          self.accept = '.csv';
          break;
        case 2:
          self.accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          break;
        case 3:
          self.accept = 'application/pdf';
          break;
        case 4:
          self.accept = '.doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
          break;
        case 5:
          self.accept = 'text/plain';
          break;
        case 6:
          self.accept = '.ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation';
          break;
        default:
          self.accept = '';
          break;
      }
    },
    GetDDGroupReplaceDB_Stream() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDGroupReplaceDB_Stream(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupReplace = dataResponse.data;
          } else {
            self.DDGroupReplace = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    AddVectorperChunk() {
      let self = this;
      self.AddVector = true;
      self.Add.textORG = null;
    },
    EditVectorperChunk(item) {
      let self = this;
      self.EditVector = true;
      self.Edit.id = item.id;
      self.Edit.textORG = item.textORG;
      // self.closeUploaddialog();
    },
    SaveEdit() {
      let self = this;
      if (!self.Edit.textORG) {
        alert('Please Fill All The Fields!');
        return;
      }
      let temp = {
        ID: self.Edit.id,
        Content: self.Edit.textORG,
        MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
        groupReplaceID: self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID),
        DetectLanguage: self.requestVector.DetectLanguage,
      };
      self.dialog = true;
      try {
        self.$call.SaveEditVector_Stream(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });

              self.GetByVector();
              self.closeUploaddialog();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log('catch : DeleteGroup');


      }
    },


    closeUploaddialog() {
      let self = this;
      self.EditVector = false;
      self.Edit.id = null;
      self.Edit.textORG = null;
    },

    Delete_ListFilePM_ById_Stream(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionVector'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.Delete_ListFilePM_ById_Stream(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.GetListFile_PrivateMemoryStream("");
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log('catch : DeleteGroup');
      }
    },
    DeleteById(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionVector'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteVectorDBNameById_Stream(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log('catch : DeleteGroup');
      }
    },
    DeleteByName(name_data) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionVectorName'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;

              let DataName_FileId = {
                name: name_data,
                FileId: self.requestVector.fileId
              }
              self.$call.DeleteVectorDBNameByName_Stream(
                DataName_FileId,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.dataUpdate = 0;
                    self.dataAll = 0;
                    self.actionEdit = false;
                    self.requestVector.searchVectorDBName2 = null;
                    //self.Delete_ListFilePM_ById(self.requestVector.fileId);
                    self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log('catch : DeleteGroup');
      }
    },
    processUploadImage(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestUpload.entity = null;
        this.uploadedFiles = [];
        return;
      }
      if (this.FileUploadLimit != null && this.FileUploadLimit != "" && this.FileUploadLimit != undefined && this.FileUploadLimit != 0) {
        const maxSize = this.FileUploadLimit * 1024; // this.FileUploadLimit KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: 'error',
            title: `ไฟล์มีขนาดใหญ่เกิน ${this.FileUploadLimit} KB`,
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      else {
        const maxSize = 2048 * 1024; // 2048 KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: 'error',
            title: `ไฟล์มีขนาดใหญ่เกิน 2048 KB`,
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      const file = e[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.fileDataUrl = e.target.result;
        this.ValidateImage(this.files);
        this.UploadImage()
      };
      reader.readAsDataURL(file);
    },
    ValidateImage(files) {
      const formDataDoc = new FormData();
      formDataDoc.append('entity', files[0]);
      this.uploadedFiles = files;
      this.requestUpload.entity = formDataDoc;
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
        this.ConfirmProcess();
      };
    },
    ValidateCSVVector(csv, files) {
      const formDataDoc = new FormData();
      formDataDoc.append('entity', files[0]);
      this.uploadedFiles = files;
      this.requestVector.entity = formDataDoc;
    },
    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('importPrivate_MemoryTitle'),
          // text: "คุณต้องการนำเข้า Vector",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.Save();
          }
        });
    },
    UploadImage() {
      let self = this;
      if (!self.requestUpload.entity) {
        alert('Please Fill All The Fields!');
        return;
      }

      // self.requestVector.vectordbName = self.KeyTopic;

      self.requestUpload.USER_CHANNEL = self.User_Id;
      // self.requestVector.TopicID = self.Log_History_TopicID;

      self.loadingImage = true;
      try {
        self.$call.UploadImage_Stream(
          self.requestUpload,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.ImageURL = dataResponse.data;
              self.requestUpload.entity = null;
              self.uploadedFiles = [];
            }
            else {
              self.$swal.fire({
                icon: 'error',
                title: this.$t('errorUploadImage'),
                showConfirmButton: false,
                timer: 2500,
              });
              self.ClearImage();
            }
            self.loadingImage = false;
          },
          (errorResource) => {
            self.$swal.fire({
              icon: 'error',
              title: this.$t('errorUploadImage'),
              showConfirmButton: false,
              timer: 2500,
            });
            self.loadingImage = false;
            self.ImageURL = null;
            self.fileDataUrl = null;
            self.requestUpload.entity = null;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // if(self.Log_History_TopicID == -1){
        self.GetTopicStream("Start");
        // }
        // this.LogTrace(error, 'DeleteGroup');

        console.log('catch : DeleteGroup');
      }
    },
    ClearImage() {
      let self = this;
      self.ImageURL = null;
      self.fileDataUrl = null;
      self.loadingImage = false;
      self.requestUpload.entity = null;
      self.uploadedFiles = [];
    },
    Save() {
      let self = this;
      if (!self.requestVector.modelType || !self.KeyTopic || !self.requestVector.entity
        || !self.requestVector.topVDB) {
        alert('Please Fill All The Fields!1');
        return;
      }
      // self.requestVector.modelType = self.requestVector.modelType == null || !self.requestVector.modelType ? (self.modelType == null ? 1 : self.modelType) : self.requestVector.modelType;
      // if (!self.Add.textORG || !self.requestVector.modelType || !self.searchVectorDBName2) {
      //   alert('Please Fill All The Fields!');
      //   return;
      // }
      if (self.requestVector.modelType == 3 && !self.requestVector.customCharacter) {
        alert('Please Fill All The Fields!2');
        return;
      }
      if (self.requestVector.MaxLimitedCharacter == null || self.requestVector.MaxLimitedCharacter == "" || self.requestVector.MaxLimitedCharacter == undefined) {
        alert('Please fill in the Custom Max Character');
        return;
      }
      self.requestVector.searchVectorDBName2 = (self.requestVector.searchVectorDBName2 == null ? "" : self.requestVector.searchVectorDBName2);
      //self.requestVector.fileName = (self.requestVector.fileName == null ? "" : self.requestVector.fileName);
      if (self.requestVector.searchVectorDBName2 == "" || self.requestVector.searchVectorDBName2.replace(/ /g, '') == "") {

        if (self.uploadedFiles != null && self.uploadedFiles.length > 0) {

          var indexLast_Name_uploadedFiles = self.uploadedFiles[0].name.lastIndexOf(".");

          self.requestVector.searchVectorDBName2 = self.uploadedFiles[0].name.substring(0, (indexLast_Name_uploadedFiles == -1 ? self.uploadedFiles[0].name.length : indexLast_Name_uploadedFiles));
        }

      }

      self.requestVector.vectordbName = self.KeyTopic;

      self.requestVector.USER_CHANNEL = self.User_Id;
      self.requestVector.TopicID = self.Log_History_TopicID;
      self.dialog = true;
      try {
        self.requestVector.groupReplaceID = self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID);
        self.$call.UploadCSV2Vector_Stream(
          self.requestVector,
          (dataResponse) => {
            // if(self.Log_History_TopicID == -1){
            self.GetTopicStream("Start");
            // }
            // self.GetListFile_PrivateMemory("");
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.KeyTopic = self.requestVector.vectordbName;
              self.requestVector.entity = null;
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;
              self.uploadedFiles = [];
              self.requestVector.fileId = dataResponse.data.fileId;
              self.GetByVector();
            }
            self.dialog = false;
          },
          (errorResource) => {

            // if(self.Log_History_TopicID == -1){
            self.GetTopicStream("Start");
            // }
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // if(self.Log_History_TopicID == -1){
        self.GetTopicStream("Start");
        // }
        // this.LogTrace(error, 'DeleteGroup');

        console.log('catch : DeleteGroup');
      }
    },
    SaveFile() {
      let self = this;
      self.requestVector.modelType = 1;
      
      if (self.requestVector.MaxLimitedCharacter == null || self.requestVector.MaxLimitedCharacter == "" || self.requestVector.MaxLimitedCharacter == undefined) {
        alert('Please fill in the Custom Max Character');
        return;
      }
      
      self.requestVector.fileName = this.GetUuidv4_Fun();
      self.requestVector.searchVectorDBName2 = this.GetUuidv4_Fun();
      self.requestVector.vectordbName = self.KeyTopic;

      self.requestVector.USER_CHANNEL = self.User_Id;
      self.requestVector.TopicID = self.Log_History_TopicID;
      self.dialog = true;
      try {
        self.requestVector.groupReplaceID = self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID);
        self.requestVector.fileId = -1;
        self.requestVector.deleteAll = false;
        self.$call.UploadCSV2Vector_Stream(
          self.requestVector,
          (dataResponse) => {
            
            // self.GetTopicStream("Start");
            
            if (dataResponse.status == 0) {
              
              self.KeyTopic = self.requestVector.vectordbName;
              self.requestVector.entity = null;
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;
              self.uploadedFiles = [];
              self.requestVector.fileId = dataResponse.data.fileId;
              self.GetByVector();
            }
            self.dialog = false;
          },
          (errorResource) => {
            
            self.GetTopicStream("Start");
            
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        
        self.GetTopicStream("Start");
        

        console.log('catch : DeleteGroup');
      }
    },
    ClearValuePrivate_Memory() {

      let self = this;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.searchVectorDBName2 = null;
      self.tempgroupReplaceID = null;
      self.doctype = null;
      self.vectortype = null;
      self.requestVector.modelType = null;
      self.requestVector.customCharacter = null;
      self.requestVector.DetectLanguage = true;



      self.dataTable = [];
      self.searchTotalTable = 0;
      self.totalTable = 0;



      self.dataUpdate = 0;
      self.dataAll = 0;
      self.exceptionFlag = false;


      self.loadingTable = false;
      self.isSearch = false;
      // self.isFirst = false;
      self.showTable = true;
      self.options = { "page": 1, "itemsPerPage": self.itemsPerPage, "sortBy": [], "sortDesc": [false], "groupBy": [], "groupDesc": [], "mustSort": false, "multiSort": false },

        self.sortBy = [];
      self.sortDesc = [];
      if (self.Axios_VECTOR != null) {
        self.Axios_VECTOR.abort();
      }
    },

    GetByVector() {
      let self = this;
      self.$nextTick(() => {
        if (self.requestVector.fileId == null || self.requestVector.fileId == -1 || self.requestVector.fileId == "") {
          self.flagNew = true;
          return;
        }
        self.loadingTable = true;
        let { page, itemsPerPage } = self.options;
        // self.sortBy = (page == undefined ? null : (self.options.sortBy.length == 0 ? null : self.options.sortBy[0]));
        // self.sortDesc = (page == undefined ? null : (self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0]));

        self.sortBy = (self.options.sortBy.length == 0 ? null : self.options.sortBy[0]);
        self.sortDesc = (self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0]);

        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          name: self.KeyTopic,
          fileId: self.requestVector.fileId,
          sortDesc: self.sortDesc,
          sortBy: self.sortBy
        };

        self.Axios_VECTOR = new AbortController();

        let Config = {
          signal: self.Axios_VECTOR.signal
        }

        self.$call.ReFreshVector_Stream(temp, Config, (dataResponse) => {
          if (dataResponse.status == 0) {
            self.dataUpdate = dataResponse.data.dataUpdate;
            self.dataAll = dataResponse.data.dataAll;
            self.exceptionFlag = dataResponse.data.exceptionFlag;
            self.searchTotalTable = dataResponse.data.table.total;
            self.dataTable = dataResponse.data.table.data;
            self.totalTable = dataResponse.data.table.total;
            self.tempgroupReplaceID = dataResponse.data.groupReplaceID;
            // if (this.$route.query.name) {

            // self.requestVector.customCharacter = dataResponse.data.customCharacter;
            //   self.requestVector.modelType = (dataResponse.data.modelType == 0 || dataResponse.data.modelType == null ? 1 : dataResponse.data.modelType);
            //  self.requestVector.DetectLanguage = dataResponse.data.detectLanguage;
            if (this.$route.query.name) {
              self.requestVector.customCharacter = dataResponse.data.customCharacter;
              self.requestVector.modelType = dataResponse.data.modelType;
              self.requestVector.DetectLanguage = dataResponse.data.detectLanguage;
              self.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
            }
            self.AutoRefresh();
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
            self.actionEdit = false;
          }
          self.loadingTable = false;
          self.isSearch = false;
          // self.isFirst = false;
          self.showTable = true;
          self.dataTable.forEach(element => {
            element.show = self.showAllText;
          });
        },
          (errorResource) => {
            self.loadingTable = false;
            self.isSearch = false;
            console.error(errorResource);
          });
      });
    },
    ReProcess() {
      let self = this;
      if (self.requestVector.MaxLimitedCharacter == null || self.requestVector.MaxLimitedCharacter == "" || self.requestVector.MaxLimitedCharacter == undefined) {
        alert('Please fill in the Custom Max Character');
        return;
      }
      self.$swal
        .fire({
          icon: 'warning',
          title: this.$t('vectorReprocess'),
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              let data = {
                VectordbName: self.KeyTopic,
                FileId: self.requestVector.fileId,
                MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
                groupReplaceID: self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID),
                DetectLanguage: self.requestVector.DetectLanguage
              };
              self.$call.ReProcessedVector_Stream(
                data,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: 'success',
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    //self.ClearValuePrivate_Memory();
                    self.GetByVector();
                  }
                },
                (errorResource) => {
                  console.error(errorResource.message);
                }
              );
            } catch (error) {
              // this.LogTrace(error, 'ReProcess');

              console.log('catch : ReProcess');
            }
          }
        });
    },
    ReFresh() {
      try {
        let self = this;
        if ((self.KeyTopic != null && self.KeyTopic != '')) {
          let { page, itemsPerPage } = this.options;
          self.sortBy = self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
          self.sortDesc = self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
          let temp = {
            page: self.isSearch ? 1 : page,
            // perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
            perPage: itemsPerPage != -1 ? itemsPerPage : null,
            name: self.KeyTopic,
            TopicID: self.Log_History_TopicID,
            fileId: self.requestVector.fileId,
            text_org: self.searchtext_org,
            sortDesc: self.sortDesc,
            sortBy: self.sortBy,
          };
          self.Axios_VECTOR = new AbortController();

          let Config = {
            signal: self.Axios_VECTOR.signal
          }

          self.$call.ReFreshVector_Stream(temp, Config,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dataUpdate = dataResponse.data.dataUpdate;
                self.dataAll = dataResponse.data.dataAll;
                self.exceptionFlag = dataResponse.data.exceptionFlag;
                self.searchTotalTable = dataResponse.data.table.total;
                self.dataTable = dataResponse.data.table.data;
                self.totalTable = dataResponse.data.table.total;
                self.modelType = dataResponse.data.modelType;
                self.requestVector.MaxLimitedCharacter = dataResponse.data.maxLimitedCharacter;
                if(self.dataUpdate == self.dataAll){
                  this.uploadFileComplete = true;
                }
              }
              self.totalTable = self.totalTable + 1;
              self.isSearch = false;

            },
            (errorResource) => {
              self.isSearch = false;
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {
        // this.LogTrace(error, 'ReFresh');

        console.log('catch : ReFresh');
      }
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        if ((self.KeyTopic != null && self.KeyTopic != '')) {
          if (self.dataUpdate == self.dataAll || self.exceptionFlag) death_waiting = false;
          else self.ReFresh();
          // if (window.location.pathname != '/UploadVector') death_waiting = false;
        }
        console.log('Wait for 5 seconds!');
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    closeUploaddialogAdd() {
      let self = this;
      self.AddVector = false;
      self.Add.id = null;
      self.Add.textORG = null;
    },

    SaveAdd() {
      let self = this;
      // if (self.requestVector.topVDB == "" || self.requestVector.topVDB == null) {
      //   self.requestVector.topVDB = (self.requestVector.topVDB == "" ? 3 : 3);

      // }
      // if (!self.Add.textORG || !self.requestVector.modelType || !self.KeyTopic || !self.requestVector.topVDB) {

      //   alert('Please Fill All The Fields!');
      //   return;
      // }
      self.requestVector.modelType = self.requestVector.modelType == null || !self.requestVector.modelType ? (self.modelType == null ? 1 : self.modelType) : self.requestVector.modelType;

      if (!self.Add.textORG || !self.requestVector.modelType || !self.requestVector.searchVectorDBName2) {
        alert('Please Fill All The Fields!');
        return;
      }
      if (self.requestVector.modelType == 3 && !self.requestVector.customCharacter) {
        alert('Please Fill All The Fields!');
        return;
      }
      if (self.requestVector.MaxLimitedCharacter == null || self.requestVector.MaxLimitedCharacter == "" || self.requestVector.MaxLimitedCharacter == undefined) {
        alert('Please fill in the Custom Max Character');
        return;
      }
      self.requestVector.searchVectorDBName2 = (self.requestVector.searchVectorDBName2 == null ? "" : self.requestVector.searchVectorDBName2);
      if (self.requestVector.searchVectorDBName2 == "" || self.requestVector.searchVectorDBName2.replace(/ /g, '') == "") {

        self.requestVector.searchVectorDBName2 = (self.Add.textORG == null ? "" : self.Add.textORG);

      }
      self.requestVector.vectordbName = self.KeyTopic;

      let temp = {
        vectordbName: self.requestVector.vectordbName,
        modelType: self.requestVector.modelType,
        DetectLanguage: self.requestVector.DetectLanguage,
        groupReplaceID: self.tempgroupReplaceID == null ? null : JSON.stringify(self.tempgroupReplaceID),
        Content: self.Add.textORG,
        flagNew: self.flagNew,
        customCharacter: self.requestVector.customCharacter,
        USER_CHANNEL: self.User_Id,
        TopicID: self.Log_History_TopicID,
        topVDB: self.requestVector.topVDB,
        cosine: self.requestVector.cosine,
        fileId: self.requestVector.fileId,
        fileName: self.requestVector.searchVectorDBName2,
        MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
      };
      self.dialog = true;

      try {
        self.$call.SaveAddVector_Stream(
          temp,
          (dataResponse) => {

            if (dataResponse.status == 0) {
              // if(self.Log_History_TopicID == -1){
              self.GetTopicStream("Start");
              // }
              // self.GetListFile_PrivateMemory("");
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;
              self.GetByVector();
              self.closeUploaddialogAdd();

              self.requestVector.fileId = dataResponse.data.fileId;

            } else {
              // if(self.Log_History_TopicID == -1){
              self.GetTopicStream("Start");
              // }
              self.VectorDBNameDuplicate = self.KeyTopic;
              // self.searchVectorDBName2 = null;
              self.$swal.fire({
                icon: 'error',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            // if(self.Log_History_TopicID == -1){
            self.GetTopicStream("Start");
            // }
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // if(self.Log_History_TopicID == -1){
        self.GetTopicStream("Start");
        // }
        this.LogTrace(error, 'DeleteGroup');

        //console.log('catch : DeleteGroup');
      }
    },
    validateTypeFile(type) {
      let self = this;
      let doctype = 0;
      switch (type) {
        case 'text/csv':
          doctype = 1;
          break;
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          doctype = 2;
          break;
        case 'application/pdf':
          doctype = 3;
          break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          doctype = 4;
          break;
        case 'text/plain':
          doctype = 5;
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          doctype = 6;
          break;
      }
      if (self.doctype == doctype) {
        return true;
      }
      return false;
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.ReFresh()
    },
    ShowAll() {
      let self = this;
      self.showAllText = !self.showAllText;
      self.dataTable.forEach(element => {
        element.show = self.showAllText;
      });

    },
    CloseShowAll() {
      let self = this;
      self.showAllText = !self.showAllText;
      self.dataTable.forEach(element => {
        element.show = self.showAllText;
      });
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkValidate() {
      let self = this;
      if (self.requestVector.searchVectorDBName2 == '' || self.requestVector.searchVectorDBName2 == null) {
        return "Required.";
      } else if (self.VectorDBNameDuplicate == self.requestVector.searchVectorDBName2) {
        return "Duplicate.";
      }

      return true;
    },

    SaveCosine_TopVDB() {
      var that = this;

      try {
        let _Data = {
          TopicName: "Private Memory",
          KeyTopic: that.KeyTopic,
          TopicID: that.Log_History_TopicID,
          topVDB: that.requestVector.topVDB,
          cosine: that.requestVector.cosine,
          USER_CHANNEL: that.User_Id,
        };

        that.$call.SaveCosine_TopVDBStream(_Data, (Response) => {
          if (Response.status == 0 && Response.data != null) {
            that.GetTopicStream("Start");
          }
          that.PrivateMemoryDialog = false;

        },
          () => {
            console.log("catch");
            that.PrivateMemoryDialog = false;

          }
        );
      }
      catch {
        console.log("catch");
        that.PrivateMemoryDialog = false;
      }
    },
    SaveFileName_PrivateMemoryStream() {
      var that = this;

      try {
        let _Data = {
          FileId: that.requestVector.fileId,
          USER_CHANNEL: that.User_Id,
          FileName: that.requestVector.searchVectorDBName2,
        };
        that.$call.SaveFileName_PrivateMemoryStream(_Data, (Response) => {

          if (Response.status == 0 && Response.data != null) {
            that.GetListFile_PrivateMemoryStream("");
          }
          that.PrivateMemoryDialog = false;

        },
          () => {
            console.log("catch");
            that.PrivateMemoryDialog = false;

          }
        );
      }
      catch {
        console.log("catch");
        that.PrivateMemoryDialog = false;
      }
    },

    CloseFileName_PrivateMemory() {
      var that = this;

      try {
        let _Data = {
          FileId: that.requestVector.fileId,
          USER_CHANNEL: that.User_Id,
          FileName: that.requestVector.fileName
        };

        that.$call.CancelFileName_PrivateMemory(_Data, (Response) => {
          if (Response.status == 0 && Response.data != null) {
            that.GetListFile_PrivateMemoryStream("");
          }
          that.PrivateMemoryDialog = false;

        },
          () => {
            console.log("catch");
            that.PrivateMemoryDialog = false;

          }
        );
      }
      catch {
        console.log("catch");
        that.PrivateMemoryDialog = false;
      }
    },

    // CloseFileName_PrivateMemory(){
    //     var that = this;
    //     that.GetListFile_PrivateMemory("");
    //     that.PrivateMemoryDialog = false;
    // },

    GetListFile_PrivateMemoryStream(StatusText) {
      try {
        let self = this;
        if ((self.KeyTopic != null && self.KeyTopic != '')) {
          let { page, itemsPerPage } = this.options_ListFilePM;
          let temp = {
            page: self.isSearch_ListFilePM ? 1 : page,
            perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable_ListFilePM,
            KeyTopic: self.KeyTopic,
            USER_CHANNEL: self.User_Id
          };
          self.$call.GetListFile_PrivateMemoryStream(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {


                self.searchTotalTable_ListFilePM = dataResponse.data.table.total;
                self.dataTable_ListFilePM = dataResponse.data.table.data;
                self.totalTable_ListFilePM = dataResponse.data.table.total;


              }
              if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {

                self.PrivateMemoryDialog_ListFile = true;
              }
            },
            (errorResource) => {
              if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {

                self.PrivateMemoryDialog_ListFile = true;
              }
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {
        // this.LogTrace(error, 'GetListFile_PrivateMemory');


        if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {

          self.PrivateMemoryDialog_ListFile = true;
        }
        console.log('catch : GetListFile_PrivateMemoryStream');
      }
    },

    SetTimeout(time) {
      var that = this;
      return setTimeout(() => {


        that.Click_StopVoice();

        console.log("End : " + new Date().toJSON())
      }, time)
    },
    click_account_voice() {
      var that = this;
      if ((that.listMessage.length > 0
        && that.listMessage[that.listMessage.length - 1].status_Process != 'END'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Stop'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Error')) {
        return;
      }
      else {

        that.TypeInputAudio = 'M';
        that.Uploaddialog = true;
      }
    },

    click_music_box() {
      var that = this;
      if ((that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process != 'END'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Stop'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Error')) {
        return;
      }
      else {

        that.TypeInputAudio = 'F';
        that.Uploaddialog = true;
      }
    },

    Click_StartVoice() {

      /* eslint-disable */

      let that = this;
      that.messageData = "";

      let _SpeechSDK = SpeechSDK;
      const audioConfig = _SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

      //  const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription("6f537e8f596943498c6d0bf2ec548b1a", "southeastasia");


      const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription(that.$root.SubscriptionKey, that.$root.Region);

      // speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1000");

      // speechConfig.outputFormat = _SpeechSDK.OutputFormat.Detailed;

      // speechConfig.speechRecognitionLanguage = that.LangPop ; 


      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1500");
      //  speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1600");


      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode], "Continuous");
      /*
            speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode], "Continuous");
      
      
      
            var autoDetectSourceLanguageConfig = _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(["en-US", "th-TH"]);
      
            that.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
      
      */

      let autoDetectSourceLanguageConfig = _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([that.LangPop]);

      that.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);


      setTimeout(() => {
        that.CountScroll = that.MaxCountScroll;
        that.ChatRef_ScrollIntoView();
      }, 5);

      let _temp_text = "";

      let _temp_textOld = "";
      that.SpeechRecognizer.recognizing = (s, e) => {

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log(`TRANSLATING: Text=${e.result.text}`);


        if (that.listMessage.length > 0) {

          if (that.listMessage[that.listMessage.length - 1].messageBot == "-") {

            that.listMessage[that.listMessage.length - 1].messageBot = "*";
            that.listMessage[that.listMessage.length - 1].messageUser = "";
          }



          that.listMessage[that.listMessage.length - 1].messageUser = _temp_textOld + (
            (_temp_textOld == ""
            ) ? "" : " ") + e.result.text;
        }

        // that.messageData += "\n"+ e.result.text;
      };
      that.SpeechRecognizer.recognized = (s, e) => {


        if (e.result.reason == _SpeechSDK.ResultReason.RecognizedSpeech) {

          // console.log(`TRANSLATED: Text=${e.result.text}`);

          // that.messageData += " " + e.result.text;

          if (that.listMessage.length > 0) {

            if (that.listMessage[that.listMessage.length - 1].messageBot == "-") {

              that.listMessage[that.listMessage.length - 1].messageBot = "*";
              that.listMessage[that.listMessage.length - 1].messageUser = "";
            }


            that.listMessage[that.listMessage.length - 1].messageUser = _temp_text + (
              (_temp_text == ""
              ) ? "" : "") + e.result.text;

            _temp_text += ((_temp_text == "") ? "" : "") + e.result.text;

            _temp_textOld = that.listMessage[that.listMessage.length - 1].messageUser;

          }

          console.log(`recognized: Text=${e.result.text}`);
        }
        else if (e.result.reason == _SpeechSDK.ResultReason.NoMatch) {
          console.log("NOMATCH: Speech could not be translated.");

        }
        else {
          console.log("ss " + e.result.reason)
        }
      };

      that.SpeechRecognizer.canceled = (s, e) => {

        console.log("canceled.");

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
      };

      that.SpeechRecognizer.sessionStarted = (s, e) => {

        console.log("sessionStarted.");

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())

        that.TimeOutStop = that.SetTimeout(that.TimeoutFirst);
        /*
        that.TimeOutStop = setTimeout(() => {
      
      
          that.Click_StopVoice();
      
          console.log("End : " + new Date().toJSON())
        }, that.TimeoutFirst);
      */
      };

      that.SpeechRecognizer.sessionStopped = (s, e) => {


        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("sessionStopped.");
        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot == "*") {


          that.messageData = that.listMessage[that.listMessage.length - 1].messageUser;
          if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart') {

            that.listMessage.pop();
          }
          // that.listMessage.pop();
          that.SendOpenAi('Click');
        }
        else if (that.listMessage.length > 0) {

          // that.listMessage.pop();
          if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart') {

            that.listMessage.pop();
          }

        }
      };

      that.SpeechRecognizer.speechStartDetected = (s, e) => {

        console.log("(StartDetected) SessionId: " + e.sessionId);

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
        }

      };
      that.SpeechRecognizer.speechEndDetected = (s, e) => {

        console.log("(EndDetected) SessionId: " + e.sessionId);



        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())

        /*
        that.TimeOutStop = setTimeout(() => {
      
      
          that.Click_StopVoice();
      
          console.log("End : " + new Date().toJSON())
        }, that.Timeout);
      */

        that.TimeOutStop = that.SetTimeout(that.Timeout);

      };

      that.SpeechRecognizer.startContinuousRecognitionAsync((e) => {
        // alert(e)
      }, (error) => {
        // alert(error)

        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'
          && error == "Error occurred during microphone initialization: NotAllowedError: Permission denied"
        ) {

          // that.listMessage.pop();

          that.listMessage[that.listMessage.length - 1].status_Process = 'END'
          that.listMessage[that.listMessage.length - 1].messageBot = "ไม่มีสิทธ์เข้าถึงไมค์";

        }
        else if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'

        ) {

          // that.listMessage.pop();

          that.listMessage[that.listMessage.length - 1].status_Process = 'END'
          that.listMessage[that.listMessage.length - 1].messageBot = "เกิดข้อผิดพลาด";

        }
        else {
          that.listMessage.push({
            messageUser: "พูด...",
            messageBot: "เกิดข้อผิดพลาด",
            status_Process: "END"
          });

        }
        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);
      });


      /*
      
            var speechRecognizer = SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
            speechRecognizer.recognizeOnceAsync((result) => {
              var languageDetectionResult = SpeechSDK.AutoDetectSourceLanguageResult.fromResult(result);
              var detectedLanguage = languageDetectionResult.language;
      
              console.log(detectedLanguage)
            },
              {});
      */

      if (that.listMessage.length > 0 && that.messageRes.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
      ) {
        if (that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes[that.messageRes.length - 1].length) {
          that.Count_messageRes[that.listMessage.length - 1] = 0;
          that.StatusPro = true;
          that.loading = true;
          that.messageRun = "";
          that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes[that.messageRes.length - 1];
          that.messageRes[that.messageRes.length - 1] = "";
        }
      }


      that.listMessage.push({
        messageUser: "พูด...",
        messageBot: "-",
        status_Process: "VoiceStart"
      });


    },
    Click_StopVoice() {

      let that = this;
      /*
            if(!(listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process == 'VoiceStart')){
              return
            }
            */
      if (that.TimeOutStop != null) {

        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }

      if (that.SpeechRecognizer != null) {
        /*
         if ( that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'
         && that.listMessage[that.listMessage.length - 1].messageBot == "*" ) {
      
           that.listMessage.pop();
         }*/
        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      /*
      if (that.TimeOutStop != null) {
      
        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }
      if (that.SpeechRecognizer != null) {
        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      
        // that.listMessage.pop();
      
        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot == "*") {
      
      
          that.messageData = that.listMessage[that.listMessage.length - 1].messageUser;
      
          that.listMessage.pop();
          that.SendOpenAi('Click');
        }
        else if (that.listMessage.length > 0) {
      
          that.listMessage.pop();
      
        }
      
      }*/
    },
    Click_StartVoiceBK() {

      /* eslint-disable */

      var that = this;
      that.messageData = "";

      let _SpeechSDK = SpeechSDK;
      const audioConfig = _SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

      //  const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription("6f537e8f596943498c6d0bf2ec548b1a", "southeastasia");


      const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription(that.$root.SubscriptionKey, that.$root.Region);

      // speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1000");

      // speechConfig.outputFormat = _SpeechSDK.OutputFormat.Detailed;

      // speechConfig.speechRecognitionLanguage = that.LangPop ; 


      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1500");
      //  speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1600");


      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode], "Continuous");
      /*
            speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode], "Continuous");
      
      
      
            var autoDetectSourceLanguageConfig = _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(["en-US", "th-TH"]);
      
            that.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
      
      */

      var autoDetectSourceLanguageConfig = _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([that.LangPop]);

      that.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);


      setTimeout(() => {
        that.CountScroll = that.MaxCountScroll;
        that.ChatRef_ScrollIntoView();
      }, 5);

      let _temp_text = "";

      let _temp_textOld = "";
      that.SpeechRecognizer.recognizing = (s, e) => {

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log(`TRANSLATING: Text=${e.result.text}`);


        if (that.listMessage.length > 0) {

          if (that.listMessage[that.listMessage.length - 1].messageBot == "-") {

            that.listMessage[that.listMessage.length - 1].messageBot = "*";
            that.listMessage[that.listMessage.length - 1].messageUser = "";
          }



          that.listMessage[that.listMessage.length - 1].messageUser = _temp_textOld + (
            (_temp_textOld == ""
            ) ? "" : " ") + e.result.text;
        }

        // that.messageData += "\n"+ e.result.text;
      };
      that.SpeechRecognizer.recognized = (s, e) => {


        if (e.result.reason == _SpeechSDK.ResultReason.RecognizedSpeech) {

          // console.log(`TRANSLATED: Text=${e.result.text}`);

          // that.messageData += " " + e.result.text;

          if (that.listMessage.length > 0) {

            if (that.listMessage[that.listMessage.length - 1].messageBot == "-") {

              that.listMessage[that.listMessage.length - 1].messageBot = "*";
              that.listMessage[that.listMessage.length - 1].messageUser = "";
            }


            that.listMessage[that.listMessage.length - 1].messageUser = _temp_text + (
              (_temp_text == ""
              ) ? "" : "") + e.result.text;

            _temp_text += ((_temp_text == "") ? "" : "") + e.result.text;

            _temp_textOld = that.listMessage[that.listMessage.length - 1].messageUser;

          }

          console.log(`recognized: Text=${e.result.text}`);
        }
        else if (e.result.reason == _SpeechSDK.ResultReason.NoMatch) {
          console.log("NOMATCH: Speech could not be translated.");

        }
        else {
          console.log("ss " + e.result.reason)
        }
      };

      that.SpeechRecognizer.canceled = (s, e) => {

        console.log("canceled.");

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
      };

      that.SpeechRecognizer.sessionStarted = (s, e) => {

        console.log("sessionStarted.");

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())

        that.TimeOutStop = that.SetTimeout(that.TimeoutFirst);
        /*
        that.TimeOutStop = setTimeout(() => {
      
      
          that.Click_StopVoice();
      
          console.log("End : " + new Date().toJSON())
        }, that.TimeoutFirst);
      */
      };

      that.SpeechRecognizer.sessionStopped = (s, e) => {


        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("sessionStopped.");
        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot == "*") {


          that.messageData = that.listMessage[that.listMessage.length - 1].messageUser;
          if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart') {

            that.listMessage.pop();
          }
          // that.listMessage.pop();
          that.SendOpenAi('Click');
        }
        else if (that.listMessage.length > 0) {

          // that.listMessage.pop();
          if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart') {

            that.listMessage.pop();
          }

        }
      };

      that.SpeechRecognizer.speechStartDetected = (s, e) => {

        console.log("(StartDetected) SessionId: " + e.sessionId);

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
        }

      };
      that.SpeechRecognizer.speechEndDetected = (s, e) => {

        console.log("(EndDetected) SessionId: " + e.sessionId);



        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())

        /*
        that.TimeOutStop = setTimeout(() => {
      
      
          that.Click_StopVoice();
      
          console.log("End : " + new Date().toJSON())
        }, that.Timeout);
      */



        that.TimeOutStop = that.SetTimeout(that.Timeout);

      };

      that.SpeechRecognizer.startContinuousRecognitionAsync((e) => {
        // alert(e)
      }, (error) => {
        // alert(error)

        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'
          && error == "Error occurred during microphone initialization: NotAllowedError: Permission denied"
        ) {

          // that.listMessage.pop();

          that.listMessage[that.listMessage.length - 1].status_Process = 'END'
          that.listMessage[that.listMessage.length - 1].messageBot = "ไม่มีสิทธ์เข้าถึงไมค์";

        }
        else if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'

        ) {

          // that.listMessage.pop();

          that.listMessage[that.listMessage.length - 1].status_Process = 'END'
          that.listMessage[that.listMessage.length - 1].messageBot = "เกิดข้อผิดพลาด";

        }
        else {
          that.listMessage.push({
            messageUser: "พูด...",
            messageBot: "เกิดข้อผิดพลาด",
            status_Process: "END"
          });

        }
        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);
      });


      /*
      
            var speechRecognizer = SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
            speechRecognizer.recognizeOnceAsync((result) => {
              var languageDetectionResult = SpeechSDK.AutoDetectSourceLanguageResult.fromResult(result);
              var detectedLanguage = languageDetectionResult.language;
      
              console.log(detectedLanguage)
            },
              {});
      */

      if (that.listMessage.length > 0 && that.messageRes.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END') {
        if (that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes[that.messageRes.length - 1].length) {
          that.Count_messageRes[that.listMessage.length - 1] = 0;
          that.StatusPro = true;
          that.loading = true;
          that.messageRun = "";
          that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes[that.messageRes.length - 1];

          that.messageRes[that.messageRes.length - 1] = "";
        }
      }


      that.listMessage.push({
        messageUser: "พูด...",
        messageBot: "-",
        status_Process: "VoiceStart"
      });


    },
    Click_StopVoiceBK() {

      var that = this;
      /*
            if(!(listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process == 'VoiceStart')){
              return
            }
            */
      if (that.TimeOutStop != null) {

        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }

      if (that.SpeechRecognizer != null) {
        /*
         if ( that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'
         && that.listMessage[that.listMessage.length - 1].messageBot == "*" ) {
      
           that.listMessage.pop();
         }*/
        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      /*
      if (that.TimeOutStop != null) {
      
        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }
      if (that.SpeechRecognizer != null) {
        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      
        // that.listMessage.pop();
      
        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot == "*") {
      
      
          that.messageData = that.listMessage[that.listMessage.length - 1].messageUser;
      
          that.listMessage.pop();
          that.SendOpenAi('Click');
        }
        else if (that.listMessage.length > 0) {
      
          that.listMessage.pop();
      
        }
      
      }*/
    },



    Convest_Speech_To_Text(Ob_DataFile) {

      var that = this;
      let formData = new FormData();
      let OB_DF = Ob_DataFile;

      if (that.listMessage.length > 0 && that.messageRes.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
      ) {
        if (that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes[that.messageRes.length - 1].length) {
          that.Count_messageRes[that.listMessage.length - 1] = 0;
          that.StatusPro = true;
          that.loading = true;
          that.messageRun = "";
          that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes[that.messageRes.length - 1];
          that.messageRes[that.messageRes.length - 1] = "";
        }
      }

      if (OB_DF.Status == false) {


        that.listMessage.push({
          messageUser: "ไฟล์เสียง",
          messageBot: OB_DF.manualContent,
          status_Process: "END"
        });


        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);


        return;
      } else {

        // Reset status indicator for new message
        that.hasStatusUpdates = false;
        that.savedStatusList = [];
        that.savedStatusCompleted = false;

        that.listMessage.push({
          messageUser: "ไฟล์เสียง " + OB_DF.NameFile,
          messageBot: "",
          status_Process: "Process"
        });


        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);

      }


      that.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: that.Axios_ControllerAduio.signal
      }

      formData.append("FileSoeech", OB_DF.DataFile);
      formData.append("LangPop", that.LangPop);

      that.$call.GetConvest_Speech_To_Text(formData, Config, (response) => {

        if (response.status == 0 && response.data.status == true) {
          //console.log(response)


          that.listMessage.pop();
          if (response.data.data != "") {

            that.messageData = response.data.data;




            that.SendOpenAi('Click');

          } else {

            that.listMessage.push({
              messageUser: "ไม่พบข้อมูลเสียงในไฟล์",
              messageBot: "",
              status_Process: "END"
            });
          }
        }
        else {
          // that.listMessage.pop();

          // that.listMessage.push({
          //   messageUser: "ไม่พบข้อมูลเสียงในไฟล์",
          //   messageBot: "",
          //   status_Process: "END"
          // });
          if (that.listMessage.length > 0) {

            ///that.listMessage[that.listMessage.length - 1].messageUser = "ไฟล์เสียง";
            that.listMessage[that.listMessage.length - 1].messageBot = response.data.textError;
            that.listMessage[that.listMessage.length - 1].status_Process = "END";
          }

        }
      },
        () => {

          if (that.listMessage.length > 0) {

            //  that.listMessage[that.listMessage.length - 1].messageUser = "ไฟล์เสียง";
            that.listMessage[that.listMessage.length - 1].messageBot = "แปลงไฟล์เสียงไม่ได้";
            that.listMessage[that.listMessage.length - 1].status_Process = "END";
          }
        });



    },
    Click_FileButtonVoid() {
      var that = this;
      if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process != 'END' &&
        that.listMessage[that.listMessage.length - 1].status_Process != 'Stop') {
        return;
      }

      document.getElementById("inputFileVoid").click();
    },
    Chang_InputFileVoid(e) {
      var that = this;
      const files = e.target.files;

      if ((files[0] == undefined)) {
        /*
        let Output = {
          Status: false,
          NameFile: null,
          DataFile: null,
          manualContent: "ไม่พบไฟล์เสียง"
        }
      */
        // that.Convest_Speech_To_Text(Output);

        return;
      }




      if (files[0] !== undefined && (files[0].type == "audio/wav" || files[0].type == "audio/mpeg"
        || files[0].type == "audio/x-m4a")) {

        // if (files[0] !== undefined && (["audio/wav", "audio/mpeg", "audio/x-m4a", "audio/ogg",
        //   "audio/flac", "audio/webm", "audio/mp4"].indexOf(files[0].type) != -1)) {



        /*
        if (this.fileName_H.lastIndexOf(".") <= 0) {
          
          return;
        }
        */
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {

          let Output = {
            Status: true,
            NameFile: files[0].name,
            DataFile: files[0],
            manualContent: files[0].type
          }
          document.getElementById("inputFileVoid").value = "";
          that.Convest_Speech_To_Text(Output);
        });
      } else {
        let Output = {
          Status: false,
          NameFile: null,
          DataFile: null,
          manualContent: "รองรับไฟล์ MP3, WAV และ M4A เท่านั้น"
        }
        document.getElementById("inputFileVoid").value = "";

        that.Convest_Speech_To_Text(Output);
      }

    },

    GetUuidv4_Fun() {

      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },

    GetUuidv4() {

      let that = this;
      let da = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );


      that.User_Id = da;

      that.User_Id_Show = da;
    },
    GetUuidv4_Fun_User_Id_Null() {



      let that = this;

      let Uuid = "10000000-1000-4000-8000-100000000000-9000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );

      return Uuid;


    },
    async OpenFullStream() {

      let that = this;

      // if (that.auth_token == "" || that.auth_token == null) {

      try {
        that.auth_token = "";
        await that.$call.GetTokenFullStream({}, async (response) => {

          if (response.status == 0 && response.data.status) {
            that.auth_token = response.data.data;
            that.Time_Delay = response.data.timeDelay;

            let routeData = that.$router.resolve({ name: 'FullStream', query: { auth_token: that.auth_token, userId: null } });


            window.open(routeData.href, '_blank');

          }
          else {
            alert(response.data.data.textError)
          }
        },
          () => {
            alert("เกิดข้อผิดพลาด")
          }
        );
      }
      catch {
        alert("เกิดข้อผิดพลาด")
      }


      // }
      // else {

      //   let routeData = that.$router.resolve({ name: 'FullStream', query: { auth_token: that.auth_token, userId: null } });


      //   window.open(routeData.href, '_blank');
      // }
    },

    Shift_Enter_MessageData() {

      let that = this;


      that.point = that.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (that.$refs.RefMessageData.$refs.input.selectionStart - 1);


      that.$nextTick(() => {
        that.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        that.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;

        if (that.$refs.RefMessageData.$refs.input &&
          that.$refs.RefMessageData.$refs.input.selectionStart >= that.messageData.length

        ) {

          const height = that.$refs.RefMessageData.$refs.input.scrollHeight
          // const minHeight = parseInt(that.$refs.RefMessageData.$refs.input.rows, 10) * parseFloat(10)


          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          that.$refs.RefMessageData.$refs.input.scrollTop = height;
        }

      })


    },
    Ctrl_Enter_MessageData() {

      var that = this;


      that.point = that.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (that.$refs.RefMessageData.$refs.input.selectionStart - 1);
      if (that.messageData.length > 0) {
        that.messageData = that.messageData.slice(0, _point + 1) + '\n' + that.messageData.slice(_point + 1);
        // that.$refs.RefMessageData.$refs.input.selectionEnd  = _point;
        // that.$refs.RefMessageData.$refs.input.selectionStart= _point;

        //    that.$refs.RefMessageData.$refs.input.setSelectionRange(0,0)
      }
      else {
        that.messageData += '\n';
      }

      that.$nextTick(() => {
        that.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        that.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;

        if (that.$refs.RefMessageData.$refs.input &&
          that.$refs.RefMessageData.$refs.input.selectionStart >= that.messageData.length

        ) {

          const height = that.$refs.RefMessageData.$refs.input.scrollHeight
          // const minHeight = parseInt(that.$refs.RefMessageData.$refs.input.rows, 10) * parseFloat(10)


          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          that.$refs.RefMessageData.$refs.input.scrollTop = height;
        }

      })


    },

    Chang_History() {
      let that = this;
      // stop voice
      if (that.TimeOutStop != null) {
        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }
      if (that.SpeechRecognizer != null) {
        that.listMessage.pop();
        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (that.Axios_ControllerAduio != null) {
        that.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (that.Axios_Controller.length != 0) {
        that.Axios_Controller[that.listMessage.length > 0 ? that.listMessage.length - 1 : 0].abort();
      }
      that.Stop_Flag = true;
      that.CountScroll = that.MaxCountScroll;
      that.messageData = "";
      that.consumedQuickReplyMessage = null;
      that.messageRes = [];
      that.listMessage = [];
      that.Axios_Controller = [];
      that.Count_messageRes = [];
      that.StatusPro = false;
    },
    StopMessage() {
      let that = this;
      if (that.listMessage.length == 0 ||
        (that.listMessage.length > 0 && (
          that.listMessage[that.listMessage.length - 1].status_Process == 'Stop' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'END' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'Error')
        )
      ) {
        if (that.listMessage[that.listMessage.length - 1].messageBot.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot.substring(that.listMessage[that.listMessage.length - 1].messageBot.length - 47, that.listMessage[that.listMessage.length - 1].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
          that.listMessage[that.listMessage.length - 1].messageBot = that.listMessage[that.listMessage.length - 1].messageBot.substring(0, that.listMessage[that.listMessage.length - 1].messageBot.length - 47);
        }
        return;
      }
      // stop Text_Run 
      if (that.TimeOutText_Run != null) {
        clearTimeout(that.TimeOutText_Run);
        that.TimeOutText_Run = null;
      }
      // stop voice
      if (that.TimeOutStop != null) {
        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }
      if (that.SpeechRecognizer != null) {
        that.listMessage.pop();
        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (that.Axios_ControllerAduio != null) {
        that.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (that.Axios_Controller.length != 0) {
        that.Axios_Controller[that.listMessage.length > 0 ? that.listMessage.length - 1 : 0].abort();
      }
      that.Stop_Flag = true;
      if (that.listMessage.length > 0 && that.messageRes.length > 0) {
        if (that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes[that.messageRes.length - 1].length) {
          that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes[that.messageRes.length - 1];
        }

      }
      if (that.listMessage.length > 0 && that.messageRes.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
        && that.listMessage[that.listMessage.length - 1].messageBot != null) {
        if (that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes[that.messageRes.length - 1].length) {
          that.Count_messageRes[that.listMessage.length - 1] = 0;
          that.StatusPro = true;
          that.loading = true;
          that.messageRun = "";
          that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes[that.messageRes.length - 1];
          that.messageRes[that.messageRes.length - 1] = "";

          setTimeout(() => {
            that.CountScroll = that.MaxCountScroll;
            that.ChatRef_ScrollIntoView();
          }, 5);
          return;
        }
      }
      if (that.listMessage.length > 0) {
        that.listMessage[that.listMessage.length - 1].status_Process = "Stop";
      }
      that.listMessage[that.listMessage.length - 1].messageBot = that.listMessage[that.listMessage.length - 1].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
      that.messageData = "";
      if (that.messageRes.length > 0) {
        that.messageRes[that.messageRes.length - 1] = "";
      } else {
        that.messageRes[0] = "";
      }

      that.Count_messageRes[that.listMessage.length - 1] = 0;
      that.StatusPro = false;
    },
    StopMessageByIndex(IndexMessage) {
      let that = this;

      if (that.listMessage.length == 0 ||
        (that.listMessage.length > 0 && (
          that.listMessage[IndexMessage].status_Process == 'Stop' ||
          that.listMessage[IndexMessage].status_Process == 'END' ||
          that.listMessage[IndexMessage].status_Process == 'Error')
        )
      ) {
        return;
      }

      // stop Text_Run 
      if (that.TimeOutText_Run != null) {

        clearTimeout(that.TimeOutText_Run);
        that.TimeOutText_Run = null;
      }

      // strp Open ai
      if (that.Axios_Controller.length != 0) {
        that.Axios_Controller[IndexMessage].abort();
      }
      // that.Stop_Flag = true;
      if (that.listMessage.length > 0 &&
        that.listMessage[IndexMessage].messageBot.length < that.messageRes[IndexMessage].length) {

        that.listMessage[IndexMessage].messageBot = that.messageRes[IndexMessage];

      }
      //

      if (that.listMessage.length > 0 &&
        that.listMessage[IndexMessage].status_Process == 'END'
        && that.listMessage[IndexMessage].messageBot != null
        && that.listMessage[IndexMessage].messageBot.length < that.messageRes[IndexMessage].length) {

        that.Count_messageRes[that.listMessage.length - 1] = 0;
        that.StatusPro = true;
        that.loading = true;
        that.messageRun = "";
        that.listMessage[IndexMessage].messageBot = that.messageRes[IndexMessage];

        that.messageRes[IndexMessage] = "";

        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);


        return;
      }


      if (that.listMessage.length > 0) {
        that.listMessage[IndexMessage].status_Process = "ChatChain";
      }

      that.listMessage[IndexMessage].messageBot = that.listMessage[IndexMessage].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
    },
    StopMessageBK() {
      var that = this;

      if (that.listMessage.length == 0 ||
        (that.listMessage.length > 0 && (
          that.listMessage[that.listMessage.length - 1].status_Process == 'Stop' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'END' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'Error')
        )
      ) {
        return;
      }


      // stop voice
      if (that.TimeOutStop != null) {

        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }

      if (that.SpeechRecognizer != null) {

        that.listMessage.pop();

        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      //




      // stop File
      if (that.Axios_ControllerAduio != null) {
        that.Axios_ControllerAduio.abort();
      }
      //


      // strp Open ai
      if (that.Axios_Controller.length != 0) {
        that.Axios_Controller[that.listMessage.length > 0 ? that.listMessage.length - 1 : 0].abort();
      }


      that.Stop_Flag = true;
      if (that.listMessage.length > 0 &&
        that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes[IndexMessage].length) {

        that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes[IndexMessage];

      }

      that.messageData = "";

      that.messageRes[IndexMessage] = "";
      that.Count_messageRes[that.listMessage.length - 1] = 0;
      that.StatusPro = false;
    },

    Clear_listMessage() {
      var that = this;

      if (that.listMessage.length == 0 || (that.listMessage.length > 0 &&
        (that.listMessage[that.listMessage.length - 1].status_Process == 'Process' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'Send_Message' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'))) {
        return;
      }

      // let _User_Id = "";
      // if (that.User_Id == that.UserPrincipalName + ":" + that.User_Id) {
      //   _User_Id = that.User_Id;
      // }
      // else {
      //   _User_Id = that.User_Id;
      // }

      let dataPost = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": that.SessionID,
            "source": {
              "type": "user",
              // "userId": "@{variables('varUserID')}"
              // "userId": "Ubfa478f7877585996689e93a01f38248"
              //"userId": UserId_Data
              // "userId": ""

              "userId": that.User_Id
              // "userId": that.User_Id
              // "userId": _User_Id + "<|UserID|>" + that.UserPrincipalName
            },
            "message": {
              "id": "325708",
              "type": "text",
              // "text": DataSend
              // "text": "ประวัติประเทศไทย"

              // "topicID": that.Log_History_TopicID,

              "topicModelID": that.TopicModelID_long,
              "topicID": that.Log_History_TopicID,
              "keyTopic": that.KeyTopic,



              "text": ":clearhistory"
            }
            // ,"stream": true
          }
        ]
      };


      let Config = {
        onUploadProgress: () => {
          console.log("onUploadProgress");
        },
        onDownloadProgress: () => {
          console.log("onDownloadProgress");

        },
        // headers: {
        //   'Content-Length': contentLength
        // },

        maxRedirects: 0 // avoid buffering the entire stream
      }

      that.$call.GptStreamPOST(dataPost, Config, () => {
        that.listMessage = [];
        that.messageData = "";
        that.consumedQuickReplyMessage = null;
        that.pendingContinueQuestion = null;
        if (that.messageRes.length > 0) {
          that.messageRes[that.messageRes.length - 1] = "";
        } else {
          that.messageRes[0] = "";
        }
        that.Count_messageRes[that.listMessage.length - 1] = 0;
        that.StatusPro = false;


        that.DataLog = {
          Prompt: "",
          Vector: "",
          ReplySQL: "",
          ReplyDataSelect: "",
          Memory: "",
          Translate: "",
          FlowActionIntent: "",
          GPT_Model: {
            ModelID: "",
            ModelName: "",
            Provider: "",
            Model: "",
            Extension: "",
            Description: "",
            promptTemplate: "",
            gender: "",
            vectordbName: "",
            TopVDB: "",
            internet: "",
            feedback: "",
            HistoryCount: "",
            HistoryMinute: "",
            temperature: "",
            top_p: "",
            frequency_penalty: "",
            presence_penalty: "",
            Stop: "",
            max_tokens: "",
            IsStream: "",
            EndpointURL: ""
          },
          Text: "",
          TextVector: "",
          VectorCoise: "",
          Private_Memory: ""
        }

      },
        () => {


        });







    },

    ChatRef_ScrollIntoView() {

      var that = this;
      if (that.$refs.ChatScreRef && that.CountScroll >= that.MaxCountScroll &&
        Math.round(that.$refs.ChatScreRef.scrollTop + that.$refs.ChatScreRef.clientHeight) <= that.$refs.ChatScreRef.scrollHeight) {


        that.$refs.ChatRef.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });

        that.CountScroll = 0;
      }



      that.CountScroll++;
    },

    SendOpenAi(K_in) {
      let that = this;
      if(that.uploadFileComplete == false && that.pickedFileType != null)
        return;

      that.GetDateTime()

      if (that.listMessage.length > 0 && that.messageRes.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
        && that.listMessage[that.listMessage.length - 1].messageBot != null) {
        if (that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes[that.messageRes.length - 1].length) {
          that.Count_messageRes[that.listMessage.length - 1] = 0;
          that.StatusPro = true;
          that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes[that.messageRes.length - 1];

          that.messageRes[that.messageRes.length - 1] = "";

          setTimeout(() => {
            that.CountScroll = that.MaxCountScroll;
            that.ChatRef_ScrollIntoView();
          }, 5);

          if (that.messageData == "") {
            return;
          }
        }
      }


      if ((that.messageData == "" && that.fileDataUrl == null)) {
        return;
      }
      if ((that.listMessage.length > 0 && (that.listMessage[that.listMessage.length - 1].status_Process != 'END'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Error'
        && that.listMessage[that.listMessage.length - 1].status_Process != 'Stop'))
        && !that.IsChainMassage) {
        return;
      }




      /*
            let _messageData = that.messageData;
      
      
      
            if (_messageData.length > 0 && _messageData[_messageData.length - 1] == "\n") {
      
              _messageData = _messageData.slice(0, _messageData.length - 1);
            }
      */
      let _messageData = that.messageData;
      let _messageImage = "";
      let _messagePickedFile = "";
      that.messageData = "";
      let IndexMessageOld = that.listMessage.length - 1;
      if (that.ImageURL != "" && that.ImageURL != null) {
        _messageImage = `![image](${that.ImageURL})\n`;
      }
      if (that.pickedFileType != null && that.uploadFileComplete) {
        _messagePickedFile = `<img src="${that.GetFileTypeImg(that.requestVector.doctype)}" width="16" height="16" style="vertical-align: middle;"> <small>${that.pickedFileName}</small>\n`;;
      }
      if (that.listMessage[IndexMessageOld] != undefined && that.IsChainMassage) {
        if (that.listMessage[IndexMessageOld].status_Process != "END") {
          that.StopMessageByIndex(IndexMessageOld);
          that.StopForChain = true;
        }
      }
      
      // Reset status indicator for new message
      that.hasStatusUpdates = false;
      that.savedStatusList = [];
      that.savedStatusCompleted = false;
      
      that.listMessage.push({
        messageUser: _messagePickedFile + _messageImage + _messageData,
        messageBot: '',
        status_Process: 'Process',
        requestTime: that.today,
        responseTime: null,
      });
      let IndexMessage = that.listMessage.length - 1;
      // if(that.listMessage.find(e => e.status_Process == 'Process') != undefined)
      // {
      //   that.listMessage.push({
      //     messageUser: _messageImage + _messageData,
      //     messageBot: '',
      //     status_Process: 'Process',
      //     requestTime: that.today,
      //     responseTime: null,
      //   });
      // }
      // else{
      //   that.listMessage.push({
      //     messageUser: _messageImage + _messageData,
      //     messageBot: '',
      //     status_Process: 'VoiceStart',
      //     requestTime: that.today,
      //     responseTime: null,
      //   });
      // }

      setTimeout(() => {
        that.CountScroll = that.MaxCountScroll;
        that.ChatRef_ScrollIntoView();
      }, 5);


      if (that.KeyTopic == null || that.KeyTopic == "" || that.Log_History_TopicID == -1) {
        that.KeyTopic = that.GetUuidv4_Fun();

      }


      if (that.listTopic.length > 0 && that.listTopic[0].topicID == -1) {
        that.listTopic[0].topicName = _messageData;

        that.listTopic[0].keyTopic = that.KeyTopic;
      }



      let dataPost = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": that.SessionID,
            "source": {
              "type": "user",
              // "userId": "@{variables('varUserID')}"
              // "userId": "Ubfa478f7877585996689e93a01f38248"
              //"userId": UserId_Data
              // "userId": ""

              "userId": that.User_Id
            },
            "message": {
              "id": "325708",
              "type": "text",
              // "text": DataSend
              // "text": "ประวัติประเทศไทย"
              "ImageURL": that.ImageURL == "" || that.IsAllowImage == false ? null : that.ImageURL,
              "topicModelID": that.TopicModelID_long,
              "topicID": that.Log_History_TopicID,
              "keyTopic": that.KeyTopic,


              "text": (that.pickedFileType != null ? _messagePickedFile : "") + _messageData,
              "continueQuestion": that.pendingContinueQuestion,
              "accessLevel": that.AccessLevel
            },
            "PersonalInfoToken": that.personalInfoToken
            // ,"stream": true
          }
        ]
      };
      that.pendingContinueQuestion = null;
      that.Stop_Flag = false;
      that.messageRes[IndexMessage] = "";
      that.Count_messageRes[IndexMessage] = 0;
      that.StatusPro = true;
      that.ClearImage();
      that.ClearUploadedFile();
      // that.loading = true;
      // that.messageRun = "";

      that.Axios_Controller[IndexMessage] = new AbortController();

      let Config = {
        signal: that.Axios_Controller[IndexMessage].signal,
        onUploadProgress: () => {

          // that.text_data += "s";


          that.Text_Run(IndexMessage);

          if (that.listMessage[IndexMessage].messageBot == "") {
            try {


              // setTimeout(() => {
              //   that.GetLogStream(_messageData);
              // }, 200);

              /*
                            setTimeout(() => {
                              that.GetTopicStream("Steam");
                              // alert("55")
                            }, 100);
              */
              // that.GetTopicStream("Steam");

            } catch {
            }
          }
        },
        onDownloadProgress: progressEvent => {
          // const xhr = progressEvent.event.target
          const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
          try {

            if (that.listMessage[IndexMessage].messageBot == "" || that.listMessage[IndexMessage].messageBot == '<span class="blinking-cursor" style="">|</span>') {
              try {




                // that.$parent.$parent.$parent.GetModelFirst_Value(null);

                that.GetTopicStream("Steam");
              } catch {


                that.DataLog = {
                  Prompt: "",
                  Vector: "",
                  ReplySQL: "",
                  ReplyDataSelect: "",
                  Memory: "",
                  Translate: "",
                  FlowActionIntent: "",
                  GPT_Model: {
                    ModelID: "",
                    ModelName: "",
                    Provider: "",
                    Model: "",
                    Extension: "",
                    Description: "",
                    promptTemplate: "",
                    gender: "",
                    vectordbName: "",
                    TopVDB: "",
                    internet: "",
                    feedback: "",
                    HistoryCount: "",
                    HistoryMinute: "",
                    temperature: "",
                    top_p: "",
                    frequency_penalty: "",
                    presence_penalty: "",
                    Stop: "",
                    max_tokens: "",
                    IsStream: "",
                    EndpointURL: ""
                  },
                  Text: "",
                  VectorCoise: "",
                  Private_Memory: ""
                };
              }
            }

            that.GetDateTime()
            const { responseText } = xhr
            // console.log("=====responseText======");
            // console.log(responseText);

            that.listMessage[IndexMessage].status_Process = "Send_Message";
            that.listMessage[IndexMessage].responseTime = that.today;

            let _responseText = responseText.replaceAll("data: [DONE]", "");
            _responseText = _responseText.replaceAll("|ContactAgent|true", "");
            if(_responseText.indexOf("|Products|[") != -1){
              var tempJson = _responseText.split("|Products|");
              _responseText = tempJson[0];
              self.products = JSON.parse(tempJson[1]);
            }
            else if(_responseText.indexOf("|logID|") != -1){
              var tempJson = _responseText.split("|logID|");
              _responseText = tempJson[0];
            }


            /* eslint-disable */


            //_responseText = _responseText.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");


            _responseText = _responseText.replace(/(?:      \n|     \n|    \n|   \n|  \n| \n)/g, "\n");
            _responseText = _responseText.replace(/(?:\n      ```|\n     ```|\n    ```|\n   ```|\n  ```|\n ```)/g, "\n```");

            // _responseText = _responseText.replace(/(?:\n      ```markdown\n|\n     ```markdown\n|\n    ```markdown\n|\n   ```markdown\n|\n  ```markdown\n|\n ```markdown\n)/g, "\n```markdown\n");

            // _responseText = _responseText.replace(/(?:\n      ```\n\n|\n     ```\n\n|\n    ```\n\n|\n   ```\n\n|\n  ```\n\n|\n ```\n\n)/g, "\n```\n");


            _responseText = _responseText.replace(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
            _responseText = _responseText.replace(/(?:\n```\n\n)/g, "\n<||End||>\n\n");

            // _responseText = _responseText.replace(/(?:\n```\n)/g, "\n```\n");

            _responseText = _responseText.replace(/(?:\n```\n```python|\n   ```\n   ```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
            _responseText = _responseText.replace(/(?:\n```\n```javascript|\n   ```\n   ```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");

            _responseText = _responseText.replace(/(?:\n```\n)/g, "\n<||StarAll||>\n");
            _responseText = _responseText.replace(/(?:\n```python)/g, "\n<||StarPython||>");
            _responseText = _responseText.replace(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
            _responseText = _responseText.replace(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");

            // _responseText = _responseText.replace(/(?:\`)/g, "\\`");


            let Sp_RT = _responseText.split("<||");


            for (let I_Sp_RT = 0; I_Sp_RT < Sp_RT.length; I_Sp_RT++) {

              let Sp_Value = Sp_RT[I_Sp_RT].split("||>");
              if (I_Sp_RT >= 1 && Sp_Value.length > 1) {


                let Sp_Value_Old = Sp_RT[I_Sp_RT - 1].split("||>");
                if (Sp_Value[0].indexOf("End") != -1) {

                  for (let II_Sp_RT = I_Sp_RT - 1; II_Sp_RT > 0; II_Sp_RT--) {

                    try {

                      let Sp_Value_Old_Loop = Sp_RT[II_Sp_RT].split("||>");


                      // if (Sp_Value.length > 1 && Sp_Value_Old.length > 1 && Sp_Value_Old_Loop.length > 1) {

                      if (Sp_Value_Old.length > 1 && Sp_Value_Old_Loop.length > 1) {


                        let x = 0;

                        if (Sp_Value[0].indexOf("End") != -1 && Sp_Value_Old[0].indexOf("Star") != -1) {
                          let re_SVO = Sp_Value_Old[0].replace("Star", "End");

                          //    Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", "<||" + re_SVO + "||>");
                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");

                          break;
                        }
                        else if (Sp_Value[0].indexOf("End") != -1 && Sp_Value_Old[0].indexOf("End") != -1
                          && Sp_Value_Old_Loop[0].indexOf("Star") != -1 &&
                          Sp_Value_Old_Loop[0].indexOf(Sp_Value_Old[0].replace("End", "Star")) == -1
                        ) {

                          let re_SVO = Sp_Value_Old_Loop[0].replace("Star", "End");

                          // Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", "<||" + re_SVO + "||>");

                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");

                          break;
                        }
                        else {
                          let dd = 0;
                        }

                      }

                    } catch (e) {

                      // let ddd = 0;
                    }
                  }
                }

                else if (((I_Sp_RT + 1) < Sp_RT.length) && Sp_Value[0].indexOf("StarAll") != -1) {

                  let Sp_Value_New = Sp_RT[I_Sp_RT + 1].split("||>");


                  if (Sp_Value_Old[0].indexOf("Star") != -1
                    && Sp_Value_New.length > 1 && Sp_Value_New[0].indexOf("Star") != -1) {
                    let re_SVO = Sp_Value_Old[0].replace("Star", "End");

                    // Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", "<||" + re_SVO + "||>");

                    Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("StarAll||>", re_SVO + "||>");

                    // break;
                  }
                }
              }

              if (I_Sp_RT == Sp_RT.length - 1) {
                for (let Iii_Sp_RT = 0; Iii_Sp_RT < Sp_RT.length; Iii_Sp_RT++) {

                  if (Sp_RT[Iii_Sp_RT].indexOf("||>") != -1) {
                    // Sp_RT[Iii_Sp_RT] = (Sp_RT[Iii_Sp_RT].indexOf("End") != -1 ? '\r\n' : "") + "<||" + Sp_RT[Iii_Sp_RT];
                    Sp_RT[Iii_Sp_RT] = "<||" + Sp_RT[Iii_Sp_RT];
                  }
                }

                _responseText = Sp_RT.join("");
              }






              /*
                            _responseText = _responseText.replaceAll("<||StarMarkdown||>", "\n`````\n");
                              _responseText = _responseText.replaceAll("<||EndMarkdown||>", "`````\n\n");
              
                              _responseText = _responseText.replaceAll("<||StarAll||>", "\n```\n");
              
                              _responseText = _responseText.replaceAll("<||EndAll||>", "\n```\n");
                              _responseText = _responseText.replaceAll("<||StarJavascript||>", "\n```javascript\n");
                              _responseText = _responseText.replaceAll("<||EndJavascript||>", "\n```\n\n");
                              _responseText = _responseText.replaceAll("<||StarPython||>", "\n```python\n");
                              _responseText = _responseText.replaceAll("<||EndPython||>", "\n```\n\n");
              */

              _responseText = _responseText.replaceAll("<||StarMarkdown||>", "\n`````\n");
              _responseText = _responseText.replaceAll("<||EndMarkdown||>", "`````\n");

              _responseText = _responseText.replaceAll("<||StarAll||>", "```");
              _responseText = _responseText.replaceAll("<||EndAll||>", "```");


              _responseText = _responseText.replaceAll("<||StarJavascript||>", "```javascript");
              _responseText = _responseText.replaceAll("<||EndJavascript||>", "```");
              _responseText = _responseText.replaceAll("<||StarPython||>", "```python");
              _responseText = _responseText.replaceAll("<||EndPython||>", "```");


              _responseText = _responseText.replaceAll("<||Star||>", "```");
              _responseText = _responseText.replaceAll("<||End||>", "```");

            }



            //_responseText = _responseText.replace(/(?:\\n\\n|\n\n)/g, "\n");
            // _responseText = _responseText.replace(/(?:\\\```|\\```)/g, "\\```");
            _responseText = _responseText.replace(/(?:\\\```|\\```|\```)/g, "<||TextMarkdown||>");

            _responseText = _responseText.replace(/(?:\\\`|\\`)/g, "\\`");

            _responseText = _responseText.replaceAll("<||TextMarkdown||>", "\```");


            // _responseText = _responseText.replaceAll(" '", " '");

            _responseText = _responseText.replaceAll("(```", "(\\```");
            _responseText = _responseText.replaceAll("(``", "(\\``");
            _responseText = _responseText.replaceAll("(`", "(\\`");
            _responseText = _responseText.replaceAll("` ` `", "`` ` ``");





            if (_responseText.indexOf("<!DOCTYPE html>") == 0 && _responseText.indexOf("```html\n<!DOCTYPE html>") == -1
              && _responseText.indexOf("```\n<!DOCTYPE html>") == -1 && _responseText.indexOf("<style>" != -1)) {

              let Sp_responseTextStart = _responseText.split("<style>");
              let Sp_responseTextEnd = Sp_responseTextStart[1].split("</style>");


              if (Sp_responseTextEnd.length > 0) {

                Sp_responseTextEnd[0] = Sp_responseTextEnd[0].replaceAll("}\n", "}\n  #V_markDown ");

              }

              _responseText = Sp_responseTextStart[0] + "<style> #V_markDown " + Sp_responseTextEnd[0] +
                (Sp_responseTextEnd.length > 1 ? " </style> " + Sp_responseTextEnd[1] : "")

            }


            // console.log("`_responseText`")
            // console.log(_responseText)







            if (_responseText.indexOf("|Text|*Streaming:true*|") != -1) {
              _responseText = _responseText.replaceAll("|Text|*Streaming:true*|", "");
              //  that.messageRun = _responseText;


              that.listMessage[that.listMessage.length - 1].messageBot = _responseText;


              that.messageRes[IndexMessage] = _responseText;

              that.messageRes[IndexMessage] = "";
              that.Count_messageRes[IndexMessage] = 0;
              that.StatusPro = false;
            }
            else if (_responseText.indexOf("|Text|*Streaming:false*|") != -1) {
              // that.messageRun = _responseText;

              _responseText = _responseText.replaceAll("|Text|*Streaming:false*|", "");
              //that.messageRun = _responseText;

              that.listMessage[that.listMessage.length - 1].messageBot = _responseText;

              that.messageRes[IndexMessage] = _responseText;


              that.messageRes[IndexMessage] = "";
              that.Count_messageRes[IndexMessage] = 0;
              that.StatusPro = false;
            }
            else {


              that.messageRes[IndexMessage] = _responseText;

              that.StatusPro = true;
            }

          } catch (e) {



            that.DataLog = {
              Prompt: "",
              Vector: "",
              ReplySQL: "",
              ReplyDataSelect: "",
              Memory: "",
              Translate: "",
              FlowActionIntent: "",
              GPT_Model: {
                ModelID: "",
                ModelName: "",
                Provider: "",
                Model: "",
                Extension: "",
                Description: "",
                promptTemplate: "",
                gender: "",
                vectordbName: "",
                TopVDB: "",
                internet: "",
                feedback: "",
                HistoryCount: "",
                HistoryMinute: "",
                temperature: "",
                top_p: "",
                frequency_penalty: "",
                presence_penalty: "",
                Stop: "",
                max_tokens: "",
                IsStream: "",
                EndpointURL: ""
              },
              Text: "",
              VectorCoise: "",
              Private_Memory: ""
            };
            console.log("e")
          }

        }
      }

      try {
        that.$call.GptStreamPOST(dataPost, Config, () => {
          if(that.listMessage[IndexMessage].messageBot == "**#Personal Information**") //that.personalInfoToken
          {
            that.listMessage[IndexMessage].status_Process = "Process";
            //#region Personal Information
            window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

            const handleMessage = async function (event) {
              try {
                // ตรวจสอบข้อมูลจาก popup
                if (!event.data || !event.data.message) return;

                const data = event.data;
                that.personalInfoToken = data.message;

                let dataPost = {
                  "events": [
                    {
                      "replyToken": "dummyToken",
                      "type": "message",
                      "timestamp": 1462629479859,
                      "fullStream": false,
                      "stream": true,
                      "SessionID": that.SessionID,
                      "source": {
                        "type": "user",
                        "userId": that.User_Id
                      },
                      "message": {
                        "id": "325708",
                        "type": "text",
                        "ImageURL": that.ImageURL == "" || that.IsAllowImage == false ? null : that.ImageURL,
                        "topicModelID": that.TopicModelID_long,
                        "topicID": that.Log_History_TopicID,
                        "keyTopic": that.KeyTopic,


                        "text": (that.pickedFileType != null ? _messagePickedFile : "") + _messageData,
                        "accessLevel": that.AccessLevel
                      },
                      "PersonalInfoToken": that.personalInfoToken
                    }
                  ]
                };

                that.$call.GptStreamPOST(dataPost, Config, () => {
                  // ทำงานเมื่อสำเร็จ (response จาก GPT)
                  that.StatusPro = false;
                  that.StopForChain = false;
                  that.successalert = true;
                  let msgRes = that.messageRes.filter(e => e != null && e != undefined && e != '');
                  if(msgRes.length > 0 && that.listMessage[IndexMessage] != undefined) {
                    that.listMessage[IndexMessage].messageBot = msgRes[IndexMessage > msgRes.length - 1 ? msgRes.length - 1 : IndexMessage];
                  }
                  that.listMessage[IndexMessage].status_Process = "END";
                  that.GetLogStream(_messageData);
                  setTimeout(() => {
                    that.CountScroll = that.MaxCountScroll;
                    that.ChatRef_ScrollIntoView();
                  }, 5);
                },
                (_response) => {

                  // กรณีเกิด error ใน GptStreamPOST
                  that.erroralert = true;

                  if (that.listMessage.length == 0) {

                  }
                  else {
                    that.StatusPro = that.StopForChain;

                    that.Count_messageRes[IndexMessage] = 0;
                    that.messageData = "";
                    if (that.listMessage.length > 0 && that.listMessage[IndexMessage].messageBot.length < that.messageRes[IndexMessage].length && !that.StopForChain) {
                      that.listMessage[IndexMessage].messageBot = (that.messageRes[IndexMessage] + "<br />Error something went wrong ...");
                    }
                    else if (!that.StopForChain && that.listMessage[IndexMessage].status_Process != "Stop") {
                      that.listMessage[IndexMessage].messageBot += "Error something went wrong ...";
                    }
                    that.messageRes[IndexMessage] = "";
                    if (that.listMessage[IndexMessage].status_Process != "Stop") {
                      that.listMessage[IndexMessage].status_Process = that.StopForChain ? "ChatChain" : "Error";
                    }

                  }

                  that.Stop_Flag = false;

                  setTimeout(() => {
                    that.CountScroll = that.MaxCountScroll;
                    that.ChatRef_ScrollIntoView();
                  }, 5);


                }
                );

              } catch (error) {
                console.log("🐞 ใน handleMessage:", error);
              } finally {
                console.log("🛑 EventListener message");
                window.removeEventListener('message', handleMessage);
              }
            };

            console.log("🧱 EventListener message");
            window.addEventListener('message', handleMessage);
            // #endregion Personal Information
          }
          // else if (true){

          // console.log("listMessage[IndexMessage].messageBot :" + that.listMessage[IndexMessage].messageBot.replaceAll('<br>', '\n'));
          //  that.listMessage[IndexMessage].messageBot = that.listMessage[IndexMessage].messageBot.replaceAll('<br>', '\n')
          // }
          else
          {
            if(_messageData.trim() == ":clearhistory")
            {
              that.listMessage = [];
              that.messageData = "";
              that.pendingContinueQuestion = null;
              if (that.messageRes.length > 0) {
                that.messageRes[that.messageRes.length - 1] = "";
              } else {
                that.messageRes[0] = "";
              }
              that.Count_messageRes[that.listMessage.length - 1] = 0;
              that.StatusPro = false;
              return;
            }
            that.StatusPro = false;
            that.StopForChain = false;
            // that.messageData = "";
            that.successalert = true;
            that.listMessage[IndexMessage].status_Process = "END";
            that.GetLogStream(_messageData);
            // that.ChatRef_ScrollIntoView();
            setTimeout(() => {
              that.CountScroll = that.MaxCountScroll;
              that.ChatRef_ScrollIntoView();
            }, 5);
          }
        },
          (_response) => {

            console.log("catch");
            // that.loading = false;
            that.erroralert = true;
            // alert("เกิดข้อผิดพลาด!!!");

            if (that.listMessage.length == 0) {

            }
            // else if (that.Stop_Flag == true) {
            //   that.listMessage[IndexMessage].status_Process = "Stop";

            // }
            else {
              that.StatusPro = that.StopForChain;

              that.Count_messageRes[IndexMessage] = 0;

              that.messageData = "";
              console.log(that.listMessage[IndexMessage]);
              if (that.listMessage.length > 0 && that.listMessage[IndexMessage].messageBot.length < that.messageRes[IndexMessage].length && !that.StopForChain) {
                that.listMessage[IndexMessage].messageBot = (that.messageRes[IndexMessage] + "<br />Error something went wrong ...");
              }
              else if (!that.StopForChain && that.listMessage[IndexMessage].status_Process != "Stop") {
                that.listMessage[IndexMessage].messageBot += "Error something went wrong ...";
              }
              that.messageRes[IndexMessage] = "";
              if (that.listMessage[IndexMessage].status_Process != "Stop") {
                that.listMessage[IndexMessage].status_Process = that.StopForChain ? "ChatChain" : "Error";
              }



            }
            that.Stop_Flag = false;
            console.log("Error : " + _response);

            setTimeout(() => {
              that.CountScroll = that.MaxCountScroll;
              that.ChatRef_ScrollIntoView();
            }, 5);


          }
        );
      }
      catch {
        console.log("E : atch ");
      }


    },


    Text_Run(IndexMessage) {

      var that = this;

      setTimeout(() => {

        if (that.messageRes[IndexMessage] == undefined) {
          return;
        }
        if ((that.Count_messageRes[IndexMessage] >= that.messageRes[IndexMessage].length && that.StatusPro == false) || that.listMessage[IndexMessage].status_Process == "ChatChain") {
          setTimeout(() => {
            that.CountScroll = that.MaxCountScroll;
            that.ChatRef_ScrollIntoView();
          }, 5);
        }
        if ((that.Count_messageRes[IndexMessage] < that.messageRes[IndexMessage].length || that.StatusPro == true) && that.listMessage[IndexMessage].status_Process != "ChatChain") {


          if (that.listMessage[IndexMessage].messageBot.length > 0 && that.listMessage[IndexMessage].messageBot.substring(that.listMessage[IndexMessage].messageBot.length - 47, that.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {

            that.listMessage[IndexMessage].messageBot = that.listMessage[IndexMessage].messageBot.substring(0, that.listMessage[IndexMessage].messageBot.length - 47);
          }


          if (that.Count_messageRes[IndexMessage] < that.messageRes[IndexMessage].length) {
            // that.messageRun += that.messageRes[that.Count_messageRes[IndexMessage]];

            if (that.messageRes[IndexMessage].length > (that.Count_messageRes[IndexMessage] + 5) && that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage]] == "<") {

              if (that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage]] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 1] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 2]
                + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 3] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 4] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 5]
                == "<br />") {

                that.listMessage[IndexMessage].messageBot += "<br />";
                that.Count_messageRes[IndexMessage] += 5;
              }
              else if (that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage]] == "<") {

                that.listMessage[IndexMessage].messageBot += that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage]];
              }
              else {
                that.listMessage[IndexMessage].messageBot += that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage]];
              }
            }
            else if ((that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage]] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 1] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 2]
              + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 3] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 4] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 5]
              + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 6] + that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + 7] == "![Image]") || that.messageImage != "") {
              let count = 0;
              for (let index = that.Count_messageRes[IndexMessage]; index < that.messageRes[IndexMessage].length; index++) {
                const element = that.messageRes[IndexMessage][index];
                that.messageImage += element;
                count++;
                if (element == ")") {
                  break;
                }
              }
              if (that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage] + (count - 1)] == ")") {
                that.listMessage[IndexMessage].messageBot += that.messageImage
                that.messageImage = "";
              }
              that.Count_messageRes[IndexMessage] += count - 1;
            }
            else {
              that.listMessage[IndexMessage].messageBot += that.messageRes[IndexMessage][that.Count_messageRes[IndexMessage]];
              that.messageImage = "";
            }

            that.Count_messageRes[IndexMessage]++;
            that.ChatRef_ScrollIntoView();
          }



          that.listMessage[IndexMessage].messageBot += `<span class="blinking-cursor" style="">|</span>`;


          if (that.Count_messageRes[IndexMessage] == that.messageRes[IndexMessage].length && that.listMessage[IndexMessage].status_Process == "END") {

            //  that.listMessage[IndexMessage].status_Process = "END";


            if (that.listMessage[IndexMessage].messageBot.length > 0 && that.listMessage[IndexMessage].messageBot.substring(that.listMessage[IndexMessage].messageBot.length - 47, that.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {

              that.listMessage[IndexMessage].messageBot = that.listMessage[IndexMessage].messageBot.substring(0, that.listMessage[IndexMessage].messageBot.length - 47);
            }
            that.listMessage[IndexMessage].messageBot = that.listMessage[IndexMessage].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
          }


          that.Text_Run(IndexMessage);
        }

      }, that.Time_Delay);

    },


    Replace_NewLine(input) {
      try {
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }
        if (input != null && input.length > 0 && (input[0] === '\n' || input[0] === '\r')) {
          input = input.slice(1, input.length);
        }

      } catch {

      }
      return input;

    },
    GetLogStream(_messageData) {
      var that = this;



      that.DataLog = {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        Translate: "",
        FlowActionIntent: "",
        GPT_Model: {
          ModelID: "",
          ModelName: "",
          Provider: "",
          Model: "",
          Extension: "",
          Description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          TopVDB: "",
          internet: "",
          feedback: "",
          HistoryCount: "",
          HistoryMinute: "",
          temperature: "",
          top_p: "",
          frequency_penalty: "",
          presence_penalty: "",
          Stop: "",
          max_tokens: "",
          IsStream: "",
          EndpointURL: ""
        },
        Text: "",
        VectorCoise: "",
        Private_Memory: ""
      };

      try {
        let _User_Id = { UserChannel: that.User_Id, TopicID: that.Log_History_TopicID };

        that.$call.GetLogMonitor(_User_Id, (response) => {

          try {

            if (response.status == 0 && response.data.status == true) {
              let DataLog_Data = response.data.data;
              that.DataLog_Data = DataLog_Data;

              let replymsg = null;
              try {

                that.Log_History_TopicID = DataLog_Data.topicID;
                replymsg = JSON.parse(DataLog_Data.replymsg);


                replymsg.Vector = that.Replace_NewLine(replymsg.Vector);
                replymsg.VectorCoise = that.Replace_NewLine(replymsg.VectorCoise);
                replymsg.Private_Memory = that.Replace_NewLine(replymsg.Private_Memory);


                if (replymsg == null) {
                  replymsg = {
                    Vector: "",
                    VectorCoise: "",
                    Private_Memory: "",
                    GPT_Model: {
                      ModelID: "",
                      ModelName: "",
                      Provider: "",
                      Model: "",
                      Extension: "",
                      Description: "",
                      promptTemplate: "",
                      gender: "",
                      vectordbName: "",
                      TopVDB: "",
                      internet: "",
                      feedback: "",
                      HistoryCount: "",
                      HistoryMinute: "",
                      temperature: "",
                      top_p: "",
                      frequency_penalty: "",
                      presence_penalty: "",
                      Stop: "",
                      max_tokens: "",
                      IsStream: ""
                    },


                  }
                }
              }
              catch {
                replymsg = {
                  Vector: "",
                  VectorCoise: "",
                  Private_Memory: "",
                  GPT_Model: {
                    ModelID: "",
                    ModelName: "",
                    Provider: "",
                    Model: "",
                    Extension: "",
                    Description: "",
                    promptTemplate: "",
                    gender: "",
                    vectordbName: "",
                    TopVDB: "",
                    internet: "",
                    feedback: "",
                    HistoryCount: "",
                    HistoryMinute: "",
                    temperature: "",
                    top_p: "",
                    frequency_penalty: "",
                    presence_penalty: "",
                    Stop: "",
                    max_tokens: "",
                    IsStream: ""
                  }
                }
              }

              let Memory = null;
              try {
                let L_Memory = JSON.parse(DataLog_Data.shortmemory);
                if (L_Memory != null && L_Memory.length > 0) {
                  Memory = "";
                  for (let i = 0; i < L_Memory.length; i++) {
                    Memory += "" + (i + 1) + ". " + L_Memory[i].role + " : " + L_Memory[i].content + "\n";
                  }
                }
                else {
                  Memory = DataLog_Data.shortmemory;
                }
              }
              catch {

                //Memory = DataLog_Data.shortmemory;
                Memory = "";
              }

              that.DataLog = {
                Prompt: replymsg.GPT_Model.promptTemplate,
                Vector: replymsg.Vector,
                ReplySQL: replymsg.ReplySQL,
                ReplyDataSelect: replymsg.ReplyDataSelect,
                Memory: Memory,
                Translate: replymsg.Translate,
                FlowActionIntent: replymsg.FlowActionIntent,
                GPT_Model: {
                  ModelID: replymsg.GPT_Model.ModelID,
                  ModelName: replymsg.GPT_Model.ModelName,
                  Provider: replymsg.GPT_Model.Provider,
                  Model: replymsg.GPT_Model.Model,
                  Extension: replymsg.GPT_Model.Extension,
                  Description: replymsg.GPT_Model.Description,
                  promptTemplate: replymsg.GPT_Model.promptTemplate,
                  gender: replymsg.GPT_Model.gender,
                  vectordbName: replymsg.GPT_Model.vectordbName,
                  TopVDB: replymsg.GPT_Model.TopVDB,
                  internet: replymsg.GPT_Model.internet,
                  feedback: replymsg.GPT_Model.feedback,
                  HistoryCount: replymsg.GPT_Model.HistoryCount,
                  HistoryMinute: replymsg.GPT_Model.HistoryMinute,
                  temperature: replymsg.GPT_Model.temperature,
                  top_p: replymsg.GPT_Model.top_p,
                  frequency_penalty: replymsg.GPT_Model.frequency_penalty,
                  presence_penalty: replymsg.GPT_Model.presence_penalty,
                  Stop: replymsg.GPT_Model.Stop,
                  max_tokens: replymsg.GPT_Model.max_tokens,
                  IsStream: replymsg.GPT_Model.IsStream,
                  EndpointURL: replymsg.GPT_Model.EndpointURL
                },
                Text: DataLog_Data.text,
                TextVector: replymsg.GPT_Model.TextVector,
                VectorCoise: replymsg.VectorCoise,
                Private_Memory: replymsg.Private_Memory

              };



            }
            else {
              that.DataLog = {
                Prompt: "",
                Vector: "",
                ReplySQL: "",
                ReplyDataSelect: "",
                Memory: "",
                Translate: "",
                FlowActionIntent: "",
                GPT_Model: {
                  ModelID: "",
                  ModelName: "",
                  Provider: "",
                  Model: "",
                  Extension: "",
                  Description: "",
                  promptTemplate: "",
                  gender: "",
                  vectordbName: "",
                  TopVDB: "",
                  internet: "",
                  feedback: "",
                  HistoryCount: "",
                  HistoryMinute: "",
                  temperature: "",
                  top_p: "",
                  frequency_penalty: "",
                  presence_penalty: "",
                  Stop: "",
                  max_tokens: "",
                  IsStream: "",
                  EndpointURL: ""
                },
                Text: "",
                TextVector: "",
                VectorCoise: "",
                Private_Memory: ""
              };
            }
          }
          catch {
            that.DataLog = {
              Prompt: "",
              Vector: "",
              ReplySQL: "",
              ReplyDataSelect: "",
              Memory: "",
              Translate: "",
              FlowActionIntent: "",
              GPT_Model: {
                ModelID: "",
                ModelName: "",
                Provider: "",
                Model: "",
                Extension: "",
                Description: "",
                promptTemplate: "",
                gender: "",
                vectordbName: "",
                TopVDB: "",
                internet: "",
                feedback: "",
                HistoryCount: "",
                HistoryMinute: "",
                temperature: "",
                top_p: "",
                frequency_penalty: "",
                presence_penalty: "",
                Stop: "",
                max_tokens: "",
                IsStream: "",
                EndpointURL: ""
              },
              Text: "",
              TextVector: "",
              VectorCoise: "",
              Private_Memory: ""
            };
          }
        }, () => {
          that.DataLog = {
            Prompt: "",
            Vector: "",
            ReplySQL: "",
            ReplyDataSelect: "",
            Memory: "",
            Translate: "",
            FlowActionIntent: "",
            GPT_Model: {
              ModelID: "",
              ModelName: "",
              Provider: "",
              Model: "",
              Extension: "",
              Description: "",
              promptTemplate: "",
              gender: "",
              vectordbName: "",
              TopVDB: "",
              internet: "",
              feedback: "",
              HistoryCount: "",
              HistoryMinute: "",
              temperature: "",
              top_p: "",
              frequency_penalty: "",
              presence_penalty: "",
              Stop: "",
              max_tokens: "",
              IsStream: "",
              EndpointURL: ""
            },
            Text: "",
            TextVector: "",
            Private_Memory: ""
          };

          console.log('GetLogStream : false')
        });
      }
      catch {

        that.Status_Error = true;
        that.Text_Status = "ไม่พบ Auth";

      }


    },
    GetToken() {


      var that = this;

      /*  
        that.axios
            .post(`${that.url}api/v0/GPTStream/GetTokenFullStream`, {})
            .then(function (response) {
              if (response.status == 200 && response.data.status == 0 && response.data.data.status  == true) {
                that.auth_token = response.data.data.data;
  
            }
            else {
              that.auth_token = "";
            }
          })
          .catch(function () {
  
            that.auth_token = "";
          });
  
  */
      try {
        that.auth_token = "";
        that.$call.GetTokenFullStream({}, (response) => {
          if (response.status == 0 && response.data.status) {
            that.auth_token = response.data.data;
            that.Time_Delay = response.data.timeDelay;
            that.maximumChatInput = 200000;
          }
          else {
            that.auth_token = "";
          }
        },
          () => {
            that.auth_token = "";
          }
        );
      }
      catch {

        that.auth_token = "";

      }

    },

    GetHistoryStream(Status) {
      var that = this;


      if (that.Loading_History_Status == true) {
        return;
      }
      try {


        let _User_Id = {
          TopicID: that.Log_History_TopicID,
          USER_CHANNEL: that.User_Id,
          ID: that.Log_History_ID,
          Take: that.Log_History_Take
        };

        that.Loading_History_Status = true;
        that.$call.GetHistoryStream(_User_Id, (response) => {

          if (response.status == 0) {

            // that.listMessage = response.data;
            let response_data = response.data
            that.Log_History_TopicID = response_data.length > 0 ? response_data[0].topicID : that.Log_History_TopicID;

            // that.listMessage = response_data.concat(that.listMessage);
            if (Status == "Start") {
              that.listMessage = response_data;
              that.SetButtom_Page();
            }
            else if (Status == "ScrollUp") {
              //that.listMessage = response_data.concat(that.listMessage);

              if (!(that.listMessage.length > 0 && that.listMessage[0].id == undefined)) {

                that.listMessage = response_data.concat(that.listMessage);
              } else {
                that.flagTopHistory = false;
              }

              if (flagTopHistory) {
                setTimeout(() => {
                  // var element = document.getElementById("ChatId_2");
                  var element1 = document.getElementById("ChatId_" + that.Log_History_ID);
                  if (element1 != undefined && element1 != null) {
                    that.$refs.ChatScreRef.scrollTop = element1.offsetTop - 20;
                  }
                  that.Loading_History_Status = false;
                }, 1);
              }
            }
          }
          else {
            // that.listMessage = [];
          }


          // setTimeout(() => {
          that.Loading_History_Status = false;
          // }, 1000);

        },
          () => {

            // setTimeout(() => {
            that.Loading_History_Status = false;
            // }, 1000);

            // that.listMessage = [];
            console.log('GetHistoryStream : false')
          }
        );
      }
      catch {
        // that.listMessage = [];

      }


    },


    GetTopicStream(status) {
      var that = this;

      try {


        let _User_Id = {
          USER_CHANNEL: that.User_Id
        };

        that.$call.GetTopicStream(_User_Id, (response) => {

          if (response.status == 0 && _User_Id.USER_CHANNEL == that.User_Id) {

            // that.listMessage = response.data;
            let response_data = response.data
            that.flagTopHistory = true;

            // that.listMessage = response_data.concat(that.listMessage);

            that.listTopic = response_data;
            if (that.listMessage.length > 0) {
              if (([':model'].some(keyword => that.listMessage[that.listMessage.length - 1].messageUser.toLowerCase().includes(keyword.toLowerCase())))) {
                if (that.Log_History_TopicID != -1) {
                  that.Time_Delay = response_data.find(e => e.topicID == that.Log_History_TopicID).timeDelay;
                  that.maximumChatInput = response_data.find(e => e.topicID == that.Log_History_TopicID).maximumChatInput;
                  that.IsAllowImage = response_data.find(e => e.topicID == that.Log_History_TopicID).isAllowImage;
                  that.FileUploadLimit = response_data.find(e => e.topicID == that.Log_History_TopicID).fileUploadLimit;
                  that.IsChainMassage = response_data.find(e => e.topicID == that.Log_History_TopicID).isChainMassage;
                }
                else {
                  that.Time_Delay = response_data[0].timeDelay;
                  that.maximumChatInput = response_data[0].maximumChatInput;
                  that.IsAllowImage = response_data[0].isAllowImage;
                  that.FileUploadLimit = response_data[0].fileUploadLimit;
                  that.IsChainMassage = response_data[0].isChainMassage;
                }
              }
            } else {
              if (response_data.length > 0) {
                if (that.Log_History_TopicID != -1) {
                  that.Time_Delay = response_data.find(e => e.topicID == that.Log_History_TopicID).timeDelay;
                  that.maximumChatInput = response_data.find(e => e.topicID == that.Log_History_TopicID).maximumChatInput;
                  that.IsAllowImage = response_data.find(e => e.topicID == that.Log_History_TopicID).isAllowImage;
                  that.FileUploadLimit = response_data.find(e => e.topicID == that.Log_History_TopicID).fileUploadLimit;
                  that.IsChainMassage = response_data.find(e => e.topicID == that.Log_History_TopicID).isChainMassage;
                }
                else {
                  that.Time_Delay = response_data[0].timeDelay;
                  that.maximumChatInput = response_data[0].maximumChatInput;
                  that.IsAllowImage = response_data[0].isAllowImage;
                  that.FileUploadLimit = response_data[0].fileUploadLimit;
                  that.IsChainMassage = response_data[0].isChainMassage;
                }

              }
            }

            if (status != "Steam") {
              console.log("GetTopicStream : true")
              if (status == "Start") {
                if (response_data.length > 0) {
                  that.Log_History_TopicID = response_data[0].topicID;
                  that.TopicName = response_data[0].topicName;
                  that.TopicModelID = response_data[0].topicModelID;
                  that.KeyTopic = response_data[0].keyTopic;


                  if (response_data[0].topicModelID_long != null) {
                    that.TopicModelID_long = response_data[0].topicModelID_long;
                  }


                  that.ModelFirst = response_data[0].topicModelID;

                  if (that.GetLogStreamStart_Flag == true) {
                    that.GetLogStreamStart_Flag = false;
                    that.GetLogStream("");
                  }
                  that.Topic_STATUS = true;

                } else {
                  // that.TopicModelID = that.ModelFirst;
                  that.GetModelFirst(null);
                }
              }


              that.GetHistoryStream("Start");
            }
            else {
              if (response_data.length > 0) {
                that.Log_History_TopicID = response_data[0].topicID;
                that.TopicName = response_data[0].topicName;
                that.TopicModelID = response_data[0].topicModelID;
                that.KeyTopic = response_data[0].keyTopic;

                if (response_data[0].topicModelID_long != null) {
                  that.TopicModelID_long = response_data[0].topicModelID_long;
                }

                that.ModelFirst = response_data[0].topicModelID;
              }
              else {
                that.GetModelFirst(null);
              }
            }
          }
          else {
            // that.listMessage = [];
            that.listTopic = [];

            that.GetModelFirst(null);
            // that.TopicModelID = that.ModelFirst;
          }



        },
          () => {

            that.listTopic = [];

            that.GetModelFirst(null);
            console.log('GetTopicStream : false')
          }
        );
      }
      catch {

        that.GetModelFirst(null);
        that.listTopic = [];

      }
    },
    ChatScreScroll(e) {
      var that = this;


      if (that.$refs.ChatScreRef.scrollTop <= that.LastScrollTop &&
        that.$refs.ChatScreRef.scrollTop == 0 && that.Loading_History_Status == false &&
        that.flagTopHistory) {


        if (that.listMessage.length > 0) {


          that.Log_History_ID = that.listMessage[0].id;



          that.GetHistoryStream("ScrollUp");


        }
      }
      else {

        // that.LastScrollTop_Status = "Down";

      }
      // var element = document.getElementById("ChatId_2");


      that.LastScrollTop = that.$refs.ChatScreRef.scrollTop;


    },

    SetButtom_Page() {
      var that = this;
      setTimeout(() => {
        if (that.$refs.ChatRef) {
          // that.$refs.ChatRef.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });

          // let ChatId_Message_ID  = "ChatId_"+ that.listMessage[that.listMessage.length -1].id;
          //   var elementChatId = document.getElementById(ChatId_Message_ID);

          that.$refs.ChatScreRef.scrollTop = that.$refs.ChatRef.offsetTop;
        }
        else {
          that.SetButtom_Page();
        }


      }, 100);
    },
    GetDateTime() {
      let month_names_short = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth(); //January is 0!

      let yyyy = today1.getFullYear();

      let hh = today1.getHours();
      let m = today1.getMinutes();

      if (dd < 10) {
        dd = '0' + dd;
      }
      if (m < 10) {
        m = '0' + m;
      }

      this.today = dd + ' ' + month_names_short[mm] + " " + hh + ":" + m;
    },

  },
  mounted() {
    var that = this;
    // ขั้นบันได Access Level (#914) — โหลดเบื้องหลัง ไม่ reject / ไม่เด้ง popup (พลาด ⇒ ค่าในตัว T0–T3)
    ensureAccessLevelsLoaded();
    that.AutoRefresh();
    that.GetDDGroupReplaceDB_Stream();

    that.SessionID = that.GetUuidv4_Fun();
    that.$nextTick(function () {
      that.GetUuidv4();
      that.GetToken();


      that.Log_History_Take = 5;
      that.Log_History_ID = null;
      that.KeyTopic = null;
      that.TopicModelID_long = -1;
      that.StatusKeyRename = false;
      that.ModelFirst = "-";



      that.TopicName = "";
      that.TopicModelID = "";
      that.Log_History_TopicID = -1;



      // that.$parent.$parent.$parent.GetModelFirst(null);
      // that.GetTopicStream("Start");

    })
    if (that.$route.query.name) {
      that.requestVector.searchVectorDBName2 = that.$route.query.name;
      that.showTable = true;
      that.actionEdit = true;
      that.flagNew = false;
    } else {
      that.dataUpdate = 0;
      that.GetMaxLimitedCharacter();
    }
    if (that.requestVector.MaxLimitedCharacter == null) {
      that.ReFresh();
    }


  },

};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.card1 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  margin-top: 1rem;
  padding: 1rem;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  padding-top: 0.5em;
}
</style>
<style>
.Log_text_textarea .v-text-field__slot {
  margin-right: -11px !important;

}

.Log_text_textarea textarea {
  /* padding-right: 13px; */

  color: black !important;
}

.rounded-circle {
  border-radius: 50%;
  width: 35px;
  height: 35px;
}

.image-container {
  transition: .5s ease;
  position: absolute;
  top: 40%;
  right: 0.55%;
  width: 35px;
  height: 35px;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 48%;
  left: 48%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.middle-progress {
  transition: .5s ease;
  position: absolute;
  top: 0%;
  left: 0%;
  color: rgb(247, 179, 78) !important;
  height: 35px !important;
  width: 35px !important;
}

.image-container:hover .middle {
  opacity: 1;
}

.delete-btn {
  background-color: rgb(247, 179, 78, 0.5) !important;
  color: white;
  font-size: 16px;
  height: 35px !important;
  width: 35px !important;
}

.responsive-table td {
  white-space: nowrap;
  /* Prevent line breaks within cells */
  overflow: hidden;
  /* Hide overflowed content */
  text-overflow: ellipsis;
  /* Show ellipsis for overflowed content */
  overflow-wrap: anywhere;
}

.attach-button {
  background-color: transparent !important;
  color: gray !important;
  border-radius: 15px !important;
  box-shadow: none;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;

  /* margin-right: 8px; Adjust space between text and button if needed */
}

.text-content-show {
  overflow: hidden;
  /* text-overflow: ellipsis; */
  /* display: -webkit-box; */
  /*-webkit-line-clamp: 2; /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

@keyframes fadeUp {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  to {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
}

.attachment-list-item {
  border-radius: 4px;
  margin: 0;
  transition: background-color 0.2s ease;
}

.attachment-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.attachment-list-item-active {
  background-color: rgba(0, 0, 0, 0.08) !important;
}

/* Fix for the minimal fab button */
.minimal-fab {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease;
  height: 32px !important;
  width: 32px !important;
  min-width: 32px !important;
  margin-left: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  background-color: #f5f5f5 !important;
}

.minimal-fab:hover {
  transform: scale(1.05);
  background-color: #e0e0e0 !important;
}

.minimal-fab .v-icon {
  font-size: 16px;
  color: #71717A;
}

:deep(#C_V_markDown) {
    /* display: block; */
    display: grid;
  }

  :deep(#C_V_markDown) p {
    margin: 0;
    /* display: contents; */
    display: block;
  }

  :deep(#C_V_markDown) table {
    border-collapse: collapse;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-spacing: 2px;
    border-color: gray;
    display: table;
    text-indent: 0;
    color: #2b2b2b !important;
  }

  :deep(#C_V_markDown) tr {
    border-top: 1px solid #c6cbd1;
    background: #fff;
  }

  :deep(#C_V_markDown) td,
  #C_V_markDown th {
    padding: 6px 13px;
    border: 1px solid #dfe2e5;
  }

  :deep(#C_V_markDown) table tr:nth-child(2n) {
    background: #d8d9da;
  }

  :deep(#C_V_markDown) li code,
  :deep(#C_V_markDown) p code {
    background-color: transparent;
    color: blue;
  }

  :deep(#C_V_markDown) code.language-markdown,
  :deep(#C_V_markDown) pre code {
    display: block;
    background: #2b2b2b;
    color: #f0f8ff;
    border: 6px, double, white;
  }

  :deep(#C_V_markDown) code {
    white-space: pre-wrap;
    background: #2b2b2b;
    color: #f0f8ff;
  }

  :deep(#C_V_markDown) pre code {
    margin: 10px 0px;
  }

  :deep(#C_V_markDown) img {
    max-width: 100%;
    max-height: 320px
  }

  :deep(#C_V_markDown) ul.contains-task-list li {
    margin-top: -20px
  }

  :deep(#C_V_markDown) br {
    content: "";
    margin: 0;
    display: block;
    font-size: 24%;
  }

  :deep(#C_V_markDown) li {
    margin-top: -1em;
  }


  :deep(#C_V_markDown) li p {

    margin-top: -22px;
  }

  :deep(#C_V_markDown) li p strong {
    margin-top: -22px;
    display: block;
  }




  :deep(#C_V_markDown) ul {
    margin-bottom: -20px;
  }

  :deep(#C_V_markDown) ol li ul {
    margin-bottom: -40px;
  }

  /* #C_V_markDown h1{
    padding-top: 6px;
  } */
  :deep(#C_V_markDown) h1,
  #C_V_markDown h2,
  #C_V_markDown h3,
  #C_V_markDown h4,
  #C_V_markDown h5 {
    /* padding-top: 15px; */

    margin-top: 7.5px;
    margin-bottom: 7.5px;
  }

  :deep(#C_V_markDown) ol {
    margin-bottom: -25px;
  }

  :deep(#C_V_markDown) blockquote {
    margin-top: -35px
  }

  :deep(#C_V_markDown) .container {
    margin-top: 0px;
  }

  .tool-btn {
    width: 30px !important;
    height: 30px !important;
  }
  .tool-box {
    border: 1px solid rgb(195 195 195);
    border-radius: 5px;
    margin-top: 10px;
    padding: 0 12px 0 12px;
  }
/* File Preview Containers */
.file-preview-container {
  position: relative;
  margin-bottom: 12px;
  border-radius: 12px;
  background: linear-gradient(145deg, #f8f9fa, #e9ecef);
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.file-preview-container:hover {
  transform: translateY(-1px);
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.15),
    0 2px 6px rgba(0, 0, 0, 0.1);
}

/* Image Preview */
.image-preview {
  width: 80px;
  height: 80px;
  overflow: hidden;
}

.preview-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.preview-close-btn {
  position: absolute;
  top: 0px;
  right: 0px;
}

/* File Attachment */
.file-attachment {
  width: 320px;
  padding: 12px;
}

.file-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.file-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(var(--v-theme-primary), 0.1);
}

.file-icon {
  width: 24px;
  height: 24px;
  transition: all 0.3s ease;
}

.file-icon.file-processing {
  filter: grayscale(100%) opacity(0.5);
}

.file-progress-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.file-details {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: rgba(var(--v-theme-on-surface), 0.87);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}

.file-progress {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-text {
  font-size: 12px;
  color: rgba(var(--v-theme-on-surface), 0.6);
  min-width: 32px;
}

.file-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: rgba(var(--v-theme-success), 1);
  font-weight: 500;
}

.file-close-btn {
  background: rgba(var(--v-theme-error), 0.1) !important;
}

/* Textarea Container */
.textarea-container {
  position: relative;
  display: flex;
}

.stream-textarea {
}
.stream-textarea .v-field__input {
  padding-left: 15px;
  mask-image: none;
}
.stream-textarea .v-field__outline {
  border-radius: 16px !important;
}
.stream-textarea .v-input__details {
  display: none !important; 
}

.stream-textarea :deep(.v-field) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.stream-textarea :deep(.v-field):hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.stream-textarea :deep(.v-field--focused) {
  border-radius: 25px !important;
  box-shadow: 0 4px 16px rgba(var(--v-theme-primary), 0.2);
}

/* Send Button */
.send-button-container {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 8px;
}

.send-btn {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.send-btn:not(:disabled):hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary), 0.3);
}

/* Attachment Menu */
.attachment-menu {
  display: flex;
  align-items: flex-end;
  padding-bottom: 8px;
}

.attachment-btn {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.attachment-btn:hover {
  background: rgba(var(--v-theme-on-surface), 0.08) !important;
  transform: scale(1.05);
}

.attachment-menu-card {
  border: none;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.12),
    0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.attachment-list {
  padding: 8px;
}

.attachment-list-item {
  border-radius: 8px;
  margin-bottom: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
  padding: 12px 16px;
}

.attachment-list-item:hover {
  background: rgba(var(--v-theme-primary), 0.08) !important;
  transform: translateX(4px);
}

.attachment-list-item:last-child {
  margin-bottom: 0;
}

.attachment-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(var(--v-theme-primary), 0.1);
  margin-right: 12px;
}

.attachment-title {
  font-weight: 500;
  font-size: 14px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .file-attachment {
    width: 280px;
  }
  
  .file-name {
    font-size: 13px;
  }
  
  .attachment-list-item {
    padding: 10px 14px;
  }
}

/* Animation for file upload progress */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
}

.file-processing {
  animation: pulse 2s infinite;
}
.topic-item {
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.topic-item .topic-menu-btn {
  opacity: 0; /* Hide by default */
  transition: opacity 0.2s ease-in-out;
}

.topic-item:hover .topic-menu-btn,
.topic-item.v-list-item--active .topic-menu-btn {
  opacity: 1; /* Show on hover or when active */
}

.topic-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topic-item-editing {
  /* Optional: Add specific styles for the editing state if needed */
  background-color: rgba(var(--v-theme-primary), 0.05);
}
.log-toggle-button {
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  width: 35px !important;
  height: 35px !important;
  display: flex !important;
}

.log-toggle-button:hover {
  transform: translateY(-1px) scale(1.05) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  border-color: rgba(var(--v-theme-primary-rgb), 0.3) !important;
}
.log-toggle-button .v-icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.log-toggle-button:hover .v-icon {
  transform: scale(1.1) !important;
}
.stream-topic-name .v-input__control {
  width: 100%;
}
.stream-message-box {
  line-break: anywhere;
  position: relative;
  padding: 4px 8px;
  background: rgb(255, 255, 255);
  box-shadow: 6px 8px 4px #00000024;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  display: flex;
  width: fit-content;
  max-width: 65%;
  margin-top: 25px;
  margin-bottom: 18px;
}

.stream-quick-reply-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
  margin: -8px 0 16px 0;
}

.stream-quick-reply-pill {
  max-width: min(360px, 100%);
  padding: 7px 14px;
  border: 1px solid #0d6efd;
  border-radius: 999px;
  background: #ffffff;
  color: #0b5ed7;
  font-size: 14px;
  line-height: 1.35;
  text-align: left;
  white-space: normal;
  overflow-wrap: anywhere;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.stream-quick-reply-pill:hover:not(:disabled) {
  background: #eef6ff;
  border-color: #084298;
  color: #084298;
}

.stream-quick-reply-pill:disabled {
  cursor: default;
  opacity: 0.55;
  background: #f8f9fa;
  border-color: #a7c7ea;
  color: #5f7898;
}

/* Finding Answer fallback box */
.finding-answer-box {
  background: rgb(249, 249, 249);
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 4px, rgba(0, 0, 0, 0.12) 0px 0px 2px;
  font-size: 14px;
  font-weight: 400;
  float: left;
  width: 175px;
  margin-top: 8px;
}

.finding-answer-text {
  padding: 10px 10px 6px 10px;
  color: #666;
}

.finding-answer-box .v-progress-linear {
  margin: 0 10px 10px 10px;
  width: calc(100% - 20px);
}

.stream-request-time {
  position: absolute;
  top: -20px;
  font-size: 10px;
  color: rgb(113, 113, 122);
  margin: 0;
  padding: 0;
  background: transparent;
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}
.stream-param-box {
  background: #f8fafd;
  border-radius: 16px;
  padding: 4px 4px 0px 4px;
  box-shadow: 0 2px 8px rgba(80,120,255,0.04);
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.stream-field-row {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 6px;
}

.stream-field-icon {
  margin-right: 2px;
}

.stream-label {
  font-size: 13px;
  font-weight: 500;
  color: #3b4252;
  min-width: 70px;
  margin-right: 8px;
}

.stream-text-field {
  flex: 1;
  min-width: 0;
  border-radius: 10px;
  width: 100%;
}
</style>
